(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/w7L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;

  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */
  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href);

    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);

  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */
  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() :

// Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

/***/ }),

/***/ "1xjh":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* @license
Papa Parse
v5.2.0
https://github.com/mholt/PapaParse
License: MIT
*/
!function (e, t) {
   true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == typeof module && "undefined" != typeof exports ? module.exports = t() : e.Papa = t();
}(this, function s() {
  "use strict";
  var f = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== f ? f : {};var n = !f.document && !!f.postMessage,
      o = n && /blob:/i.test((f.location || {}).protocol),
      a = {},
      h = 0,
      b = { parse: function parse(e, t) {
      var i = (t = t || {}).dynamicTyping || !1;U(i) && (t.dynamicTypingFunction = i, i = {});if (t.dynamicTyping = i, t.transform = !!U(t.transform) && t.transform, t.worker && b.WORKERS_SUPPORTED) {
        var r = function () {
          if (!b.WORKERS_SUPPORTED) return !1;var e = (i = f.URL || f.webkitURL || null, r = s.toString(), b.BLOB_URL || (b.BLOB_URL = i.createObjectURL(new Blob(["(", r, ")();"], { type: "text/javascript" })))),
              t = new f.Worker(e);var i, r;return t.onmessage = _, t.id = h++, a[t.id] = t;
        }();return r.userStep = t.step, r.userChunk = t.chunk, r.userComplete = t.complete, r.userError = t.error, t.step = U(t.step), t.chunk = U(t.chunk), t.complete = U(t.complete), t.error = U(t.error), delete t.worker, void r.postMessage({ input: e, config: t, workerId: r.id });
      }var n = null;b.NODE_STREAM_INPUT, "string" == typeof e ? n = t.download ? new l(t) : new p(t) : !0 === e.readable && U(e.read) && U(e.on) ? n = new g(t) : (f.File && e instanceof File || e instanceof Object) && (n = new c(t));return n.stream(e);
    }, unparse: function unparse(e, t) {
      var n = !1,
          _ = !0,
          m = ",",
          v = "\r\n",
          s = '"',
          a = s + s,
          i = !1,
          r = null;!function () {
        if ("object" != typeof t) return;"string" != typeof t.delimiter || b.BAD_DELIMITERS.filter(function (e) {
          return -1 !== t.delimiter.indexOf(e);
        }).length || (m = t.delimiter);("boolean" == typeof t.quotes || "function" == typeof t.quotes || Array.isArray(t.quotes)) && (n = t.quotes);"boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (i = t.skipEmptyLines);"string" == typeof t.newline && (v = t.newline);"string" == typeof t.quoteChar && (s = t.quoteChar);"boolean" == typeof t.header && (_ = t.header);if (Array.isArray(t.columns)) {
          if (0 === t.columns.length) throw new Error("Option columns is empty");r = t.columns;
        }void 0 !== t.escapeChar && (a = t.escapeChar + s);
      }();var o = new RegExp(q(s), "g");"string" == typeof e && (e = JSON.parse(e));if (Array.isArray(e)) {
        if (!e.length || Array.isArray(e[0])) return u(null, e, i);if ("object" == typeof e[0]) return u(r || h(e[0]), e, i);
      } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : h(e.data[0])), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [e.data])), u(e.fields || [], e.data || [], i);throw new Error("Unable to serialize unrecognized input");function h(e) {
        if ("object" != typeof e) return [];var t = [];for (var i in e) {
          t.push(i);
        }return t;
      }function u(e, t, i) {
        var r = "";"string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t));var n = Array.isArray(e) && 0 < e.length,
            s = !Array.isArray(t[0]);if (n && _) {
          for (var a = 0; a < e.length; a++) {
            0 < a && (r += m), r += y(e[a], a);
          }0 < t.length && (r += v);
        }for (var o = 0; o < t.length; o++) {
          var h = n ? e.length : t[o].length,
              u = !1,
              f = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;if (i && !n && (u = "greedy" === i ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === i && n) {
            for (var d = [], l = 0; l < h; l++) {
              var c = s ? e[l] : l;d.push(t[o][c]);
            }u = "" === d.join("").trim();
          }if (!u) {
            for (var p = 0; p < h; p++) {
              0 < p && !f && (r += m);var g = n && s ? e[p] : p;r += y(t[o][g], p);
            }o < t.length - 1 && (!i || 0 < h && !f) && (r += v);
          }
        }return r;
      }function y(e, t) {
        if (null == e) return "";if (e.constructor === Date) return JSON.stringify(e).slice(1, 25);var i = e.toString().replace(o, a),
            r = "boolean" == typeof n && n || "function" == typeof n && n(e, t) || Array.isArray(n) && n[t] || function (e, t) {
          for (var i = 0; i < t.length; i++) {
            if (-1 < e.indexOf(t[i])) return !0;
          }return !1;
        }(i, b.BAD_DELIMITERS) || -1 < i.indexOf(m) || " " === i.charAt(0) || " " === i.charAt(i.length - 1);return r ? s + i + s : i;
      }
    } };if (b.RECORD_SEP = String.fromCharCode(30), b.UNIT_SEP = String.fromCharCode(31), b.BYTE_ORDER_MARK = "\uFEFF", b.BAD_DELIMITERS = ["\r", "\n", '"', b.BYTE_ORDER_MARK], b.WORKERS_SUPPORTED = !n && !!f.Worker, b.NODE_STREAM_INPUT = 1, b.LocalChunkSize = 10485760, b.RemoteChunkSize = 5242880, b.DefaultDelimiter = ",", b.Parser = w, b.ParserHandle = i, b.NetworkStreamer = l, b.FileStreamer = c, b.StringStreamer = p, b.ReadableStreamStreamer = g, f.jQuery) {
    var d = f.jQuery;d.fn.parse = function (o) {
      var i = o.config || {},
          h = [];return this.each(function (e) {
        if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && f.FileReader) || !this.files || 0 === this.files.length) return !0;for (var t = 0; t < this.files.length; t++) {
          h.push({ file: this.files[t], inputElem: this, instanceConfig: d.extend({}, i) });
        }
      }), e(), this;function e() {
        if (0 !== h.length) {
          var e,
              t,
              i,
              r,
              n = h[0];if (U(o.before)) {
            var s = o.before(n.file, n.inputElem);if ("object" == typeof s) {
              if ("abort" === s.action) return e = "AbortError", t = n.file, i = n.inputElem, r = s.reason, void (U(o.error) && o.error({ name: e }, t, i, r));if ("skip" === s.action) return void u();"object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
            } else if ("skip" === s) return void u();
          }var a = n.instanceConfig.complete;n.instanceConfig.complete = function (e) {
            U(a) && a(e, n.file, n.inputElem), u();
          }, b.parse(n.file, n.instanceConfig);
        } else U(o.complete) && o.complete();
      }function u() {
        h.splice(0, 1), e();
      }
    };
  }function u(e) {
    this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = { data: [], errors: [], meta: {} }, function (e) {
      var t = E(e);t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);this._handle = new i(t), (this._handle.streamer = this)._config = t;
    }.call(this, e), this.parseChunk = function (e, t) {
      if (this.isFirstChunk && U(this._config.beforeFirstChunk)) {
        var i = this._config.beforeFirstChunk(e);void 0 !== i && (e = i);
      }this.isFirstChunk = !1, this._halted = !1;var r = this._partialLine + e;this._partialLine = "";var n = this._handle.parse(r, this._baseIndex, !this._finished);if (!this._handle.paused() && !this._handle.aborted()) {
        var s = n.meta.cursor;this._finished || (this._partialLine = r.substring(s - this._baseIndex), this._baseIndex = s), n && n.data && (this._rowCount += n.data.length);var a = this._finished || this._config.preview && this._rowCount >= this._config.preview;if (o) f.postMessage({ results: n, workerId: b.WORKER_ID, finished: a });else if (U(this._config.chunk) && !t) {
          if (this._config.chunk(n, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);n = void 0, this._completeResults = void 0;
        }return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(n.data), this._completeResults.errors = this._completeResults.errors.concat(n.errors), this._completeResults.meta = n.meta), this._completed || !a || !U(this._config.complete) || n && n.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), a || n && n.meta.paused || this._nextChunk(), n;
      }this._halted = !0;
    }, this._sendError = function (e) {
      U(this._config.error) ? this._config.error(e) : o && this._config.error && f.postMessage({ workerId: b.WORKER_ID, error: e, finished: !1 });
    };
  }function l(e) {
    var r;(e = e || {}).chunkSize || (e.chunkSize = b.RemoteChunkSize), u.call(this, e), this._nextChunk = n ? function () {
      this._readChunk(), this._chunkLoaded();
    } : function () {
      this._readChunk();
    }, this.stream = function (e) {
      this._input = e, this._nextChunk();
    }, this._readChunk = function () {
      if (this._finished) this._chunkLoaded();else {
        if (r = new XMLHttpRequest(), this._config.withCredentials && (r.withCredentials = this._config.withCredentials), n || (r.onload = y(this._chunkLoaded, this), r.onerror = y(this._chunkError, this)), r.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !n), this._config.downloadRequestHeaders) {
          var e = this._config.downloadRequestHeaders;for (var t in e) {
            r.setRequestHeader(t, e[t]);
          }
        }if (this._config.chunkSize) {
          var i = this._start + this._config.chunkSize - 1;r.setRequestHeader("Range", "bytes=" + this._start + "-" + i);
        }try {
          r.send(this._config.downloadRequestBody);
        } catch (e) {
          this._chunkError(e.message);
        }n && 0 === r.status && this._chunkError();
      }
    }, this._chunkLoaded = function () {
      4 === r.readyState && (r.status < 200 || 400 <= r.status ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : r.responseText.length, this._finished = !this._config.chunkSize || this._start >= function (e) {
        var t = e.getResponseHeader("Content-Range");if (null === t) return -1;return parseInt(t.substring(t.lastIndexOf("/") + 1));
      }(r), this.parseChunk(r.responseText)));
    }, this._chunkError = function (e) {
      var t = r.statusText || e;this._sendError(new Error(t));
    };
  }function c(e) {
    var r, n;(e = e || {}).chunkSize || (e.chunkSize = b.LocalChunkSize), u.call(this, e);var s = "undefined" != typeof FileReader;this.stream = function (e) {
      this._input = e, n = e.slice || e.webkitSlice || e.mozSlice, s ? ((r = new FileReader()).onload = y(this._chunkLoaded, this), r.onerror = y(this._chunkError, this)) : r = new FileReaderSync(), this._nextChunk();
    }, this._nextChunk = function () {
      this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
    }, this._readChunk = function () {
      var e = this._input;if (this._config.chunkSize) {
        var t = Math.min(this._start + this._config.chunkSize, this._input.size);e = n.call(e, this._start, t);
      }var i = r.readAsText(e, this._config.encoding);s || this._chunkLoaded({ target: { result: i } });
    }, this._chunkLoaded = function (e) {
      this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
    }, this._chunkError = function () {
      this._sendError(r.error);
    };
  }function p(e) {
    var i;u.call(this, e = e || {}), this.stream = function (e) {
      return i = e, this._nextChunk();
    }, this._nextChunk = function () {
      if (!this._finished) {
        var e,
            t = this._config.chunkSize;return t ? (e = i.substring(0, t), i = i.substring(t)) : (e = i, i = ""), this._finished = !i, this.parseChunk(e);
      }
    };
  }function g(e) {
    u.call(this, e = e || {});var t = [],
        i = !0,
        r = !1;this.pause = function () {
      u.prototype.pause.apply(this, arguments), this._input.pause();
    }, this.resume = function () {
      u.prototype.resume.apply(this, arguments), this._input.resume();
    }, this.stream = function (e) {
      this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
    }, this._checkIsFinished = function () {
      r && 1 === t.length && (this._finished = !0);
    }, this._nextChunk = function () {
      this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : i = !0;
    }, this._streamData = y(function (e) {
      try {
        t.push("string" == typeof e ? e : e.toString(this._config.encoding)), i && (i = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
      } catch (e) {
        this._streamError(e);
      }
    }, this), this._streamError = y(function (e) {
      this._streamCleanUp(), this._sendError(e);
    }, this), this._streamEnd = y(function () {
      this._streamCleanUp(), r = !0, this._streamData("");
    }, this), this._streamCleanUp = y(function () {
      this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
    }, this);
  }function i(m) {
    var a,
        o,
        h,
        r = Math.pow(2, 53),
        n = -r,
        s = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)(e[-+]?\d+)?\s*$/,
        u = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/,
        t = this,
        i = 0,
        f = 0,
        d = !1,
        e = !1,
        l = [],
        c = { data: [], errors: [], meta: {} };if (U(m.step)) {
      var p = m.step;m.step = function (e) {
        if (c = e, _()) g();else {
          if (g(), 0 === c.data.length) return;i += e.data.length, m.preview && i > m.preview ? o.abort() : (c.data = c.data[0], p(c, t));
        }
      };
    }function v(e) {
      return "greedy" === m.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
    }function g() {
      if (c && h && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + b.DefaultDelimiter + "'"), h = !1), m.skipEmptyLines) for (var e = 0; e < c.data.length; e++) {
        v(c.data[e]) && c.data.splice(e--, 1);
      }return _() && function () {
        if (!c) return;function e(e) {
          U(m.transformHeader) && (e = m.transformHeader(e)), l.push(e);
        }if (Array.isArray(c.data[0])) {
          for (var t = 0; _() && t < c.data.length; t++) {
            c.data[t].forEach(e);
          }c.data.splice(0, 1);
        } else c.data.forEach(e);
      }(), function () {
        if (!c || !m.header && !m.dynamicTyping && !m.transform) return c;function e(e, t) {
          var i,
              r = m.header ? {} : [];for (i = 0; i < e.length; i++) {
            var n = i,
                s = e[i];m.header && (n = i >= l.length ? "__parsed_extra" : l[i]), m.transform && (s = m.transform(s, n)), s = y(n, s), "__parsed_extra" === n ? (r[n] = r[n] || [], r[n].push(s)) : r[n] = s;
          }return m.header && (i > l.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + l.length + " fields but parsed " + i, f + t) : i < l.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + l.length + " fields but parsed " + i, f + t)), r;
        }var t = 1;!c.data.length || Array.isArray(c.data[0]) ? (c.data = c.data.map(e), t = c.data.length) : c.data = e(c.data, 0);m.header && c.meta && (c.meta.fields = l);return f += t, c;
      }();
    }function _() {
      return m.header && 0 === l.length;
    }function y(e, t) {
      return i = e, m.dynamicTypingFunction && void 0 === m.dynamicTyping[i] && (m.dynamicTyping[i] = m.dynamicTypingFunction(i)), !0 === (m.dynamicTyping[i] || m.dynamicTyping) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (function (e) {
        if (s.test(e)) {
          var t = parseFloat(e);if (n < t && t < r) return !0;
        }return !1;
      }(t) ? parseFloat(t) : u.test(t) ? new Date(t) : "" === t ? null : t) : t;var i;
    }function k(e, t, i, r) {
      var n = { type: e, code: t, message: i };void 0 !== r && (n.row = r), c.errors.push(n);
    }this.parse = function (e, t, i) {
      var r = m.quoteChar || '"';if (m.newline || (m.newline = function (e, t) {
        e = e.substring(0, 1048576);var i = new RegExp(q(t) + "([^]*?)" + q(t), "gm"),
            r = (e = e.replace(i, "")).split("\r"),
            n = e.split("\n"),
            s = 1 < n.length && n[0].length < r[0].length;if (1 === r.length || s) return "\n";for (var a = 0, o = 0; o < r.length; o++) {
          "\n" === r[o][0] && a++;
        }return a >= r.length / 2 ? "\r\n" : "\r";
      }(e, r)), h = !1, m.delimiter) U(m.delimiter) && (m.delimiter = m.delimiter(e), c.meta.delimiter = m.delimiter);else {
        var n = function (e, t, i, r, n) {
          var s, a, o, h;n = n || [",", "\t", "|", ";", b.RECORD_SEP, b.UNIT_SEP];for (var u = 0; u < n.length; u++) {
            var f = n[u],
                d = 0,
                l = 0,
                c = 0;o = void 0;for (var p = new w({ comments: r, delimiter: f, newline: t, preview: 10 }).parse(e), g = 0; g < p.data.length; g++) {
              if (i && v(p.data[g])) c++;else {
                var _ = p.data[g].length;l += _, void 0 !== o ? 0 < _ && (d += Math.abs(_ - o), o = _) : o = _;
              }
            }0 < p.data.length && (l /= p.data.length - c), (void 0 === a || d <= a) && (void 0 === h || h < l) && 1.99 < l && (a = d, s = f, h = l);
          }return { successful: !!(m.delimiter = s), bestDelimiter: s };
        }(e, m.newline, m.skipEmptyLines, m.comments, m.delimitersToGuess);n.successful ? m.delimiter = n.bestDelimiter : (h = !0, m.delimiter = b.DefaultDelimiter), c.meta.delimiter = m.delimiter;
      }var s = E(m);return m.preview && m.header && s.preview++, a = e, o = new w(s), c = o.parse(a, t, i), g(), d ? { meta: { paused: !0 } } : c || { meta: { paused: !1 } };
    }, this.paused = function () {
      return d;
    }, this.pause = function () {
      d = !0, o.abort(), a = U(m.chunk) ? "" : a.substring(o.getCharIndex());
    }, this.resume = function () {
      t.streamer._halted ? (d = !1, t.streamer.parseChunk(a, !0)) : setTimeout(t.resume, 3);
    }, this.aborted = function () {
      return e;
    }, this.abort = function () {
      e = !0, o.abort(), c.meta.aborted = !0, U(m.complete) && m.complete(c), a = "";
    };
  }function q(e) {
    return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }function w(e) {
    var O,
        D = (e = e || {}).delimiter,
        I = e.newline,
        T = e.comments,
        A = e.step,
        L = e.preview,
        F = e.fastMode,
        z = O = void 0 === e.quoteChar ? '"' : e.quoteChar;if (void 0 !== e.escapeChar && (z = e.escapeChar), ("string" != typeof D || -1 < b.BAD_DELIMITERS.indexOf(D)) && (D = ","), T === D) throw new Error("Comment character same as delimiter");!0 === T ? T = "#" : ("string" != typeof T || -1 < b.BAD_DELIMITERS.indexOf(T)) && (T = !1), "\n" !== I && "\r" !== I && "\r\n" !== I && (I = "\n");var M = 0,
        j = !1;this.parse = function (a, t, i) {
      if ("string" != typeof a) throw new Error("Input must be a string");var r = a.length,
          e = D.length,
          n = I.length,
          s = T.length,
          o = U(A),
          h = [],
          u = [],
          f = [],
          d = M = 0;if (!a) return R();if (F || !1 !== F && -1 === a.indexOf(O)) {
        for (var l = a.split(I), c = 0; c < l.length; c++) {
          if (f = l[c], M += f.length, c !== l.length - 1) M += I.length;else if (i) return R();if (!T || f.substring(0, s) !== T) {
            if (o) {
              if (h = [], b(f.split(D)), S(), j) return R();
            } else b(f.split(D));if (L && L <= c) return h = h.slice(0, L), R(!0);
          }
        }return R();
      }for (var p = a.indexOf(D, M), g = a.indexOf(I, M), _ = new RegExp(q(z) + q(O), "g"), m = a.indexOf(O, M);;) {
        if (a[M] !== O) {
          if (T && 0 === f.length && a.substring(M, M + s) === T) {
            if (-1 === g) return R();M = g + n, g = a.indexOf(I, M), p = a.indexOf(D, M);
          } else {
            if (-1 !== p && (p < g || -1 === g)) {
              if (!(p < m)) {
                f.push(a.substring(M, p)), M = p + e, p = a.indexOf(D, M);continue;
              }var v = x(p, m, g);if (v && void 0 !== v.nextDelim) {
                p = v.nextDelim, m = v.quoteSearch, f.push(a.substring(M, p)), M = p + e, p = a.indexOf(D, M);continue;
              }
            }if (-1 === g) break;if (f.push(a.substring(M, g)), C(g + n), o && (S(), j)) return R();if (L && h.length >= L) return R(!0);
          }
        } else for (m = M, M++;;) {
          if (-1 === (m = a.indexOf(O, m + 1))) return i || u.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: h.length, index: M }), E();if (m === r - 1) return E(a.substring(M, m).replace(_, O));if (O !== z || a[m + 1] !== z) {
            if (O === z || 0 === m || a[m - 1] !== z) {
              -1 !== p && p < m + 1 && (p = a.indexOf(D, m + 1)), -1 !== g && g < m + 1 && (g = a.indexOf(I, m + 1));var y = w(-1 === g ? p : Math.min(p, g));if (a[m + 1 + y] === D) {
                f.push(a.substring(M, m).replace(_, O)), a[M = m + 1 + y + e] !== O && (m = a.indexOf(O, M)), p = a.indexOf(D, M), g = a.indexOf(I, M);break;
              }var k = w(g);if (a.substring(m + 1 + k, m + 1 + k + n) === I) {
                if (f.push(a.substring(M, m).replace(_, O)), C(m + 1 + k + n), p = a.indexOf(D, M), m = a.indexOf(O, M), o && (S(), j)) return R();if (L && h.length >= L) return R(!0);break;
              }u.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: h.length, index: M }), m++;
            }
          } else m++;
        }
      }return E();function b(e) {
        h.push(e), d = M;
      }function w(e) {
        var t = 0;if (-1 !== e) {
          var i = a.substring(m + 1, e);i && "" === i.trim() && (t = i.length);
        }return t;
      }function E(e) {
        return i || (void 0 === e && (e = a.substring(M)), f.push(e), M = r, b(f), o && S()), R();
      }function C(e) {
        M = e, b(f), f = [], g = a.indexOf(I, M);
      }function R(e) {
        return { data: h, errors: u, meta: { delimiter: D, linebreak: I, aborted: j, truncated: !!e, cursor: d + (t || 0) } };
      }function S() {
        A(R()), h = [], u = [];
      }function x(e, t, i) {
        var r = { nextDelim: void 0, quoteSearch: void 0 },
            n = a.indexOf(O, t + 1);if (t < e && e < n && (n < i || -1 === i)) {
          var s = a.indexOf(D, n);if (-1 === s) return r;n < s && (n = a.indexOf(O, n + 1)), r = x(s, n, i);
        } else r = { nextDelim: e, quoteSearch: t };return r;
      }
    }, this.abort = function () {
      j = !0;
    }, this.getCharIndex = function () {
      return M;
    };
  }function _(e) {
    var t = e.data,
        i = a[t.workerId],
        r = !1;if (t.error) i.userError(t.error, t.file);else if (t.results && t.results.data) {
      var n = { abort: function abort() {
          r = !0, m(t.workerId, { data: [], errors: [], meta: { aborted: !0 } });
        }, pause: v, resume: v };if (U(i.userStep)) {
        for (var s = 0; s < t.results.data.length && (i.userStep({ data: t.results.data[s], errors: t.results.errors, meta: t.results.meta }, n), !r); s++) {}delete t.results;
      } else U(i.userChunk) && (i.userChunk(t.results, n, t.file), delete t.results);
    }t.finished && !r && m(t.workerId, t.results);
  }function m(e, t) {
    var i = a[e];U(i.userComplete) && i.userComplete(t), i.terminate(), delete a[e];
  }function v() {
    throw new Error("Not implemented.");
  }function E(e) {
    if ("object" != typeof e || null === e) return e;var t = Array.isArray(e) ? [] : {};for (var i in e) {
      t[i] = E(e[i]);
    }return t;
  }function y(e, t) {
    return function () {
      e.apply(t, arguments);
    };
  }function U(e) {
    return "function" == typeof e;
  }return o && (f.onmessage = function (e) {
    var t = e.data;void 0 === b.WORKER_ID && t && (b.WORKER_ID = t.workerId);if ("string" == typeof t.input) f.postMessage({ workerId: b.WORKER_ID, results: b.parse(t.input, t.config), finished: !0 });else if (f.File && t.input instanceof File || t.input instanceof Object) {
      var i = b.parse(t.input, t.config);i && f.postMessage({ workerId: b.WORKER_ID, results: i, finished: !0 });
    }
  }), (l.prototype = Object.create(u.prototype)).constructor = l, (c.prototype = Object.create(u.prototype)).constructor = c, (p.prototype = Object.create(p.prototype)).constructor = p, (g.prototype = Object.create(u.prototype)).constructor = g, b;
});

/***/ }),

/***/ "2OHv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = ['baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer', 'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName', 'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress', 'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent', 'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);

  var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
    return axiosKeys.indexOf(key) === -1;
  });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};

/***/ }),

/***/ "3bIi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("YdsM");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/***/ }),

/***/ "7/2Y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return (/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url)
  );
};

/***/ }),

/***/ "BMrJ":
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var memoize = function memoize(fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = function (fn) {
	var memo = {};

	return function (selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector];
	};
}(function (target) {
	return document.querySelector(target);
});

var singleton = null;
var singletonCounter = 0;
var stylesInsertedAtTop = [];

var fixUrls = __webpack_require__("DRTY");

module.exports = function (list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if (newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if (domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j]();
				}delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if (domStyle) {
			domStyle.refs++;

			for (var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for (; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for (var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts };
		}
	}
}

function listToStyles(list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = { css: css, media: media, sourceMap: sourceMap };

		if (!newStyles[id]) styles.push(newStyles[id] = { id: id, parts: [part] });else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement(options, style) {
	var target = getElement(options.insertInto);

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if (idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement(options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs(el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
		result = options.transform(obj.css);

		if (result) {
			// If transform returns a value, use that instead of the original css.
			// This allows running runtime transformations on the css.
			obj.css = result;
		} else {
			// If the transform function returns a falsy value, don't add this css.
			// This allows conditional loading of css
			return function () {
				// noop
			};
		}
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);
	} else if (obj.sourceMap && typeof URL === "function" && typeof URL.createObjectURL === "function" && typeof URL.revokeObjectURL === "function" && typeof Blob === "function" && typeof btoa === "function") {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function remove() {
			removeStyleElement(style);

			if (style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function remove() {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if (newObj) {
			if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
}();

function applyToSingletonTag(style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag(style, obj) {
	var css = obj.css;
	var media = obj.media;

	if (media) {
		style.setAttribute("media", media);
	}

	if (style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while (style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink(link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
 	If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
 	and there is no publicPath defined then lets turn convertToAbsoluteUrls
 	on by default.  Otherwise default to the convertToAbsoluteUrls option
 	directly
 */
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if (oldSrc) URL.revokeObjectURL(oldSrc);
}

/***/ }),

/***/ "BXyq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");
var normalizeHeaderName = __webpack_require__("M8l6");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("KRuG");
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__("KRuG");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {/* Ignore */}
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/***/ }),

/***/ "BtxX":
/***/ (function(module, exports) {

(function (root) {

  // Store setTimeout reference so promise-polyfill will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var setTimeoutFunc = setTimeout;

  function noop() {}

  // Polyfill for Function.prototype.bind
  function bind(fn, thisArg) {
    return function () {
      fn.apply(thisArg, arguments);
    };
  }

  function Promise(fn) {
    if (!(this instanceof Promise)) throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    this._state = 0;
    this._handled = false;
    this._value = undefined;
    this._deferreds = [];

    doResolve(fn, this);
  }

  function handle(self, deferred) {
    while (self._state === 3) {
      self = self._value;
    }
    if (self._state === 0) {
      self._deferreds.push(deferred);
      return;
    }
    self._handled = true;
    Promise._immediateFn(function () {
      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
      if (cb === null) {
        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
        return;
      }
      var ret;
      try {
        ret = cb(self._value);
      } catch (e) {
        reject(deferred.promise, e);
        return;
      }
      resolve(deferred.promise, ret);
    });
  }

  function resolve(self, newValue) {
    try {
      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
        var then = newValue.then;
        if (newValue instanceof Promise) {
          self._state = 3;
          self._value = newValue;
          finale(self);
          return;
        } else if (typeof then === 'function') {
          doResolve(bind(then, newValue), self);
          return;
        }
      }
      self._state = 1;
      self._value = newValue;
      finale(self);
    } catch (e) {
      reject(self, e);
    }
  }

  function reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    finale(self);
  }

  function finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) {
      Promise._immediateFn(function () {
        if (!self._handled) {
          Promise._unhandledRejectionFn(self._value);
        }
      });
    }

    for (var i = 0, len = self._deferreds.length; i < len; i++) {
      handle(self, self._deferreds[i]);
    }
    self._deferreds = null;
  }

  function Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
  }

  /**
   * Take a potentially misbehaving resolver function and make sure
   * onFulfilled and onRejected are only called once.
   *
   * Makes no guarantees about asynchrony.
   */
  function doResolve(fn, self) {
    var done = false;
    try {
      fn(function (value) {
        if (done) return;
        done = true;
        resolve(self, value);
      }, function (reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      });
    } catch (ex) {
      if (done) return;
      done = true;
      reject(self, ex);
    }
  }

  Promise.prototype['catch'] = function (onRejected) {
    return this.then(null, onRejected);
  };

  Promise.prototype.then = function (onFulfilled, onRejected) {
    var prom = new this.constructor(noop);

    handle(this, new Handler(onFulfilled, onRejected, prom));
    return prom;
  };

  Promise.all = function (arr) {
    return new Promise(function (resolve, reject) {
      if (!arr || typeof arr.length === 'undefined') throw new TypeError('Promise.all accepts an array');
      var args = Array.prototype.slice.call(arr);
      if (args.length === 0) return resolve([]);
      var remaining = args.length;

      function res(i, val) {
        try {
          if (val && (typeof val === 'object' || typeof val === 'function')) {
            var then = val.then;
            if (typeof then === 'function') {
              then.call(val, function (val) {
                res(i, val);
              }, reject);
              return;
            }
          }
          args[i] = val;
          if (--remaining === 0) {
            resolve(args);
          }
        } catch (ex) {
          reject(ex);
        }
      }

      for (var i = 0; i < args.length; i++) {
        res(i, args[i]);
      }
    });
  };

  Promise.resolve = function (value) {
    if (value && typeof value === 'object' && value.constructor === Promise) {
      return value;
    }

    return new Promise(function (resolve) {
      resolve(value);
    });
  };

  Promise.reject = function (value) {
    return new Promise(function (resolve, reject) {
      reject(value);
    });
  };

  Promise.race = function (values) {
    return new Promise(function (resolve, reject) {
      for (var i = 0, len = values.length; i < len; i++) {
        values[i].then(resolve, reject);
      }
    });
  };

  // Use polyfill for setImmediate for performance gains
  Promise._immediateFn = typeof setImmediate === 'function' && function (fn) {
    setImmediate(fn);
  } || function (fn) {
    setTimeoutFunc(fn, 0);
  };

  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) {
      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
    }
  };

  /**
   * Set the immediate function to execute callbacks
   * @param fn {function} Function to execute
   * @deprecated
   */
  Promise._setImmediateFn = function _setImmediateFn(fn) {
    Promise._immediateFn = fn;
  };

  /**
   * Change the function to execute on unhandled rejection
   * @param {function} fn Function to execute on unhandled rejection
   * @deprecated
   */
  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
    Promise._unhandledRejectionFn = fn;
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Promise;
  } else if (!root.Promise) {
    root.Promise = Promise;
  }
})(this);

/***/ }),

/***/ "DRTY":
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
	// get current location
	var location = typeof window !== "undefined" && window.location;

	if (!location) {
		throw new Error("fixUrls requires window.location");
	}

	// blank or null?
	if (!css || typeof css !== "string") {
		return css;
	}

	var baseUrl = location.protocol + "//" + location.host;
	var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
 This regular expression is just a way to recursively match brackets within
 a string.
 	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
    (  = Start a capturing group
      (?:  = Start a non-capturing group
          [^)(]  = Match anything that isn't a parentheses
          |  = OR
          \(  = Match a start parentheses
              (?:  = Start another non-capturing groups
                  [^)(]+  = Match anything that isn't a parentheses
                  |  = OR
                  \(  = Match a start parentheses
                      [^)(]*  = Match anything that isn't a parentheses
                  \)  = Match a end parentheses
              )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
  \)  = Match a close parens
 	 /gi  = Get all matches, not the first.  Be case insensitive.
  */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
			return $1;
		}).replace(/^'(.*)'$/, function (o, $1) {
			return $1;
		});

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
			//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};

/***/ }),

/***/ "ED/T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/***/ }),

/***/ "H6Qo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// CONCATENATED MODULE: ../node_modules/preact-habitat/dist/preact-habitat.es.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Removes `-` fron a string and capetalize the letter after
 * example: data-props-hello-world =>  dataPropsHelloWorld
 * Used for props passed from host DOM element
 * @param  {String} str string
 * @return {String} Capetalized string
 */
var camelcasize = function camelcasize(str) {
  return str.replace(/-([a-z])/gi, function (all, letter) {
    return letter.toUpperCase();
  });
};

/**
 * [getExecutedScript internal widget to provide the currently executed script]
 * @param  {document} document [Browser document object]
 * @return {HTMLElement}     [script Element]
 */
var getExecutedScript = function getExecutedScript() {
  return document.currentScript || function () {
    var scripts = document.getElementsByTagName("script");
    return scripts[scripts.length - 1];
  }();
};

/**
 * Get the props from a host element's data attributes
 * @param  {Element} tag The host element
 * @return {Object}  props object to be passed to the component
 */
var collectPropsFromElement = function collectPropsFromElement(element, defaultProps) {
  if (defaultProps === void 0) defaultProps = {};

  var attrs = element.attributes;

  var props = _extends({}, defaultProps);

  // collect from element
  Object.keys(attrs).forEach(function (key) {
    if (attrs.hasOwnProperty(key)) {
      var dataAttrName = attrs[key].name;
      if (!dataAttrName || typeof dataAttrName !== "string") {
        return false;
      }
      var propName = dataAttrName.split(/(data-props?-)/).pop() || '';
      propName = camelcasize(propName);
      if (dataAttrName !== propName) {
        var propValue = attrs[key].nodeValue;
        props[propName] = propValue;
      }
    }
  });

  // check for child script text/props or application/json
  [].forEach.call(element.getElementsByTagName('script'), function (scrp) {
    var propsObj = {};
    if (scrp.hasAttribute('type')) {
      if (scrp.getAttribute("type") !== "text/props" && scrp.getAttribute("type") !== "application/json") {
        return;
      }
      try {
        propsObj = JSON.parse(scrp.innerHTML);
      } catch (e) {
        throw new Error(e);
      }
      _extends(props, propsObj);
    }
  });

  return props;
};

var getHabitatSelectorFromClient = function getHabitatSelectorFromClient(currentScript) {
  var scriptTagAttrs = currentScript.attributes;
  var selector = null;
  // check for another props attached to the tag
  Object.keys(scriptTagAttrs).forEach(function (key) {
    if (scriptTagAttrs.hasOwnProperty(key)) {
      var dataAttrName = scriptTagAttrs[key].name;
      if (dataAttrName === 'data-mount-in') {
        selector = scriptTagAttrs[key].nodeValue;
      }
    }
  });
  return selector;
};

/**
 * Return array of 0 or more elements that will host our widget
 * @param  {id} attrId the data widget id attribute the host should have
 * @param  {document} scope  Docuemnt object or DOM Element as a scope
 * @return {Array}        Array of matching habitats
 */
var widgetDOMHostElements = function widgetDOMHostElements(ref) {
  var selector = ref.selector;
  var inline = ref.inline;
  var clientSpecified = ref.clientSpecified;

  var hostNodes = [];
  var currentScript = getExecutedScript();

  if (inline === true) {
    var parentNode = currentScript.parentNode;
    hostNodes.push(parentNode);
  }
  if (clientSpecified === true && !selector) {
    // user did not specify where to mount - get it from script tag attributes
    selector = getHabitatSelectorFromClient(currentScript);
  }
  if (selector) {
    [].forEach.call(document.querySelectorAll(selector), function (queriedTag) {
      hostNodes.push(queriedTag);
    });
  }
  return hostNodes;
};

/**
 * preact render function that will be queued if the DOM is not ready
 * and executed immeidatly if DOM is ready
 */
var preact_habitat_es_preactRender = function preactRender(widget, hostElements, root, cleanRoot, defaultProps) {
  hostElements.forEach(function (elm) {
    var hostNode = elm;
    if (hostNode._habitat) {
      return;
    }
    hostNode._habitat = true;
    var props = collectPropsFromElement(elm, defaultProps) || defaultProps;
    if (cleanRoot) {
      hostNode.innerHTML = "";
    }
    return Object(preact_min["render"])(Object(preact_min["h"])(widget, props), hostNode, root);
  });
};

var habitat = function habitat(Widget) {
  // Widget represents the Preact component we need to mount
  var widget = Widget;
  // preact root render helper
  var root = null;

  var render$$1 = function render$$1(ref) {
    if (ref === void 0) ref = {};
    var selector = ref.selector;if (selector === void 0) selector = null;
    var inline = ref.inline;if (inline === void 0) inline = false;
    var clean = ref.clean;if (clean === void 0) clean = false;
    var clientSpecified = ref.clientSpecified;if (clientSpecified === void 0) clientSpecified = false;
    var defaultProps = ref.defaultProps;if (defaultProps === void 0) defaultProps = {};

    var elements = widgetDOMHostElements({
      selector: selector,
      inline: inline,
      clientSpecified: clientSpecified
    });
    var loaded = function loaded() {
      if (elements.length > 0) {
        var elements$1 = widgetDOMHostElements({
          selector: selector,
          inline: inline,
          clientSpecified: clientSpecified
        });

        return preact_habitat_es_preactRender(widget, elements$1, root, clean, defaultProps);
      }
    };
    loaded();
    document.addEventListener("DOMContentLoaded", loaded);
    document.addEventListener("load", loaded);
  };

  return { render: render$$1 };
};

/* harmony default export */ var preact_habitat_es = (habitat);
//# sourceMappingURL=preact-habitat.es.js.map
// EXTERNAL MODULE: ../node_modules/axios/index.js
var axios = __webpack_require__("dZBD");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ../node_modules/papaparse/papaparse.min.js
var papaparse_min = __webpack_require__("1xjh");
var papaparse_min_default = /*#__PURE__*/__webpack_require__.n(papaparse_min);

// EXTERNAL MODULE: ../node_modules/terraformer-wkt-parser/terraformer-wkt-parser.js
var terraformer_wkt_parser = __webpack_require__("UJLu");
var terraformer_wkt_parser_default = /*#__PURE__*/__webpack_require__.n(terraformer_wkt_parser);

// EXTERNAL MODULE: ./components/Form/style.css
var style = __webpack_require__("bEsX");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./components/Form/Autocomplete.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// Google autocomplete is hard to make into
// a controlled component.

var _ref = Object(preact_min["h"])('input', {
    id: 'autocomplete',
    name: 'origin',
    type: 'text',
    placeholder: 'Enter your specific starting location (920 SW 3rd, Powell Park, etc.)'
});

var Autocomplete_Autocomplete = function (_Component) {
    _inherits(Autocomplete, _Component);

    function Autocomplete() {
        _classCallCheck(this, Autocomplete);

        var _this = _possibleConstructorReturn(this, _Component.call(this));

        _this.autocomplete = null;

        _this.handleAutocompleteSelect = _this.handleAutocompleteSelect.bind(_this);
        return _this;
    }

    Autocomplete.prototype.handleAutocompleteSelect = function handleAutocompleteSelect() {
        var place = this.autocomplete.getPlace();
        console.log(place);
        var lat = place.geometry.location.lat();
        var lng = place.geometry.location.lng();
        var name = place.name;
        this.props.handleInput({ lat: lat, lng: lng, name: name });
    };

    Autocomplete.prototype.componentDidMount = function componentDidMount() {
        var _props$programBounds = this.props.programBounds,
            bottom_left = _props$programBounds.bottom_left,
            top_right = _props$programBounds.top_right;

        var defaultBounds = new window.google.maps.LatLngBounds(new window.google.maps.LatLng(bottom_left.lat, bottom_left.lng), new window.google.maps.LatLng(top_right.lat, top_right.lng));
        var options = {
            bounds: defaultBounds,
            componentRestrictions: {
                country: 'us'
            },
            strictBounds: true
        };
        var originInput = document.getElementById('autocomplete');
        this.autocomplete = new window.google.maps.places.Autocomplete(originInput, options);
        this.autocomplete.addListener("place_changed", this.handleAutocompleteSelect);
    };

    Autocomplete.prototype.render = function render() {
        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(
                'label',
                { 'for': 'autocomplete', 'class': style_default.a.screenReaderText },
                'Starting location'
            ),
            _ref
        );
    };

    return Autocomplete;
}(preact_min["Component"]);

/* harmony default export */ var Form_Autocomplete = (Autocomplete_Autocomplete);
// CONCATENATED MODULE: ./components/Form/Tooltip.js




var Tooltip__ref = Object(preact_min["h"])(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", version: "1.1", x: "0px", y: "0px", viewBox: "0 0 120 120", style: "enable-background:new 0 0 120 120;" },
    Object(preact_min["h"])("path", { d: "M60,10c-27.7,0-50,22.3-50,50s22.3,50,50,50s50-22.3,50-50S87.7,10,60,10z M60,35.2c3.5,0,6.2,2.7,6.2,6.2s-2.7,6.2-6.2,6.2  s-6.2-2.7-6.2-6.2S56.5,35.2,60,35.2z M70.4,79c0,1-0.8,1.9-2.1,1.9H51.7c-1,0-2.1-0.6-2.1-1.9v-4.2c0-1,0.8-2.3,2.1-2.3  c1,0,2.1-0.6,2.1-1.9v-8.3c0-1-0.8-2.3-2.1-2.3c-1,0-2.1-0.6-2.1-1.9V54c0-1,0.8-2.3,2.1-2.3h12.5c1,0,2.1,1,2.1,2.3v16.7  c0,1,0.8,1.9,2.1,1.9c1,0,2.1,1,2.1,2.3V79z" })
);

var Tooltip_Tooltip = function Tooltip(props) {
    var message = props.message;

    return Object(preact_min["h"])(
        "div",
        { "class": style_default.a.tooltip },
        Tooltip__ref,
        Object(preact_min["h"])(
            "div",
            { "class": style_default.a.tooltipText },
            message
        )
    );
};

/* harmony default export */ var Form_Tooltip = (Tooltip_Tooltip);
// CONCATENATED MODULE: ./components/Form/index.js


function Form__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Form__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Form__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Form__ref = Object(preact_min["h"])(
    "legend",
    null,
    "Are you an older adult or have a disability?",
    Object(preact_min["h"])(Form_Tooltip, { message: "Age requirements vary by provider, see program details" })
);

var _ref2 = Object(preact_min["h"])(
    "label",
    { "for": "yes_eligible" },
    "Yes"
);

var _ref3 = Object(preact_min["h"])(
    "label",
    { "for": "no_eligible" },
    "No"
);

var _ref4 = Object(preact_min["h"])(
    "div",
    null,
    Object(preact_min["h"])("input", {
        type: "submit",
        value: "Get programs"
    })
);

var Form_Form = function (_Component) {
    Form__inherits(Form, _Component);

    function Form() {
        Form__classCallCheck(this, Form);

        var _this = Form__possibleConstructorReturn(this, _Component.call(this));

        _this.state = {
            eligibility_restricted: true,
            origin: {
                lat: null,
                lng: null,
                name: null
            }
        };
        return _this;
    }

    Form.prototype.onSubmit = function onSubmit(e) {
        e.preventDefault();
        // TODO handle form validation before submitting
        this.props.handleFormSubmit(this.state);
    };

    Form.prototype.handleAutocompleteInput = function handleAutocompleteInput(coords) {
        this.setState({ origin: coords });
    };

    Form.prototype.onToggle = function onToggle(e) {
        var _setState;

        var name = e.target.name;

        var checked = !this.state[name];
        this.setState((_setState = {}, _setState[name] = checked, _setState));
    };

    Form.prototype.render = function render() {
        var _this2 = this;

        return Object(preact_min["h"])(
            "form",
            { onSubmit: function onSubmit(e) {
                    return _this2.onSubmit(e);
                } },
            Object(preact_min["h"])(
                "fieldset",
                { "class": style_default.a.formLegend },
                Form__ref,
                Object(preact_min["h"])("input", {
                    type: "radio",
                    id: "yes_eligible",
                    name: "eligibility_restricted",
                    onClick: function onClick(e) {
                        return _this2.onToggle(e);
                    },
                    checked: this.state.eligibility_restricted
                }),
                _ref2,
                Object(preact_min["h"])("input", {
                    type: "radio",
                    id: "no_eligible",
                    name: "eligibility_restricted",
                    onClick: function onClick(e) {
                        return _this2.onToggle(e);
                    },
                    checked: !this.state.eligibility_restricted
                }),
                _ref3
            ),
            Object(preact_min["h"])(
                "div",
                { "class": style_default.a.autoCompleteSection },
                Object(preact_min["h"])(
                    "div",
                    null,
                    Object(preact_min["h"])(Form_Autocomplete, {
                        programBounds: this.props.programBounds,
                        handleInput: function handleInput(coords) {
                            return _this2.handleAutocompleteInput(coords);
                        }
                    })
                ),
                _ref4
            )
        );
    };

    return Form;
}(preact_min["Component"]);

/* harmony default export */ var components_Form = (Form_Form);
// EXTERNAL MODULE: ./components/Program/style.css
var Program_style = __webpack_require__("mrbf");
var Program_style_default = /*#__PURE__*/__webpack_require__.n(Program_style);

// CONCATENATED MODULE: ./components/Program/badge.js





var badge_Badge = function Badge(props) {
    var programData = props.programData;

    return Object(preact_min["h"])(
        'div',
        { 'class': Program_style_default.a.badgeRow },
        renderBadges(programData)
    );
};

var categories = {
    'medical': {
        badgeText: 'Medical Only',
        color: '#005EB8',
        tooltipText: 'Get a ride to a doctor\'s appointment'
    },
    'lunch': {
        badgeText: 'Lunch Social Service',
        color: '#ED8B00',
        tooltipText: 'Get a meal and/or take class at a local senior center'
    },
    'other': {
        badgeText: 'Door-to-Door',
        color: '#0a5f31',
        tooltipText: 'Door-to-door service will take you almost anywhere you want to go within a designated service area'
    },
    'shopping': {
        badgeText: 'Shopping',
        color: '#009639',
        tooltipText: 'Get a ride to a grocery store or shopping center.'
    },
    'route deviation': {
        badgeText: 'Route Deviation',
        color: '#1d76db',
        tooltipText: 'Call in advance to schedule a pick-up or drop-off outside the regular route'
    }
};

function renderBadges(programData) {
    var category = programData.category;

    if (Array.isArray(category)) {
        return category.map(function (cat) {
            return getCategoryBadge(categories[cat]);
        });
    }
    if (categories[category]) {
        return getCategoryBadge(categories[category]);
    }
    return '';
}

function getCategoryBadge(category) {
    var badgeText = category.badgeText,
        color = category.color,
        tooltipText = category.tooltipText;

    return Object(preact_min["h"])(
        'span',
        { 'class': Program_style_default.a.badge, style: { 'background-color': color } },
        badgeText,
        Object(preact_min["h"])(
            'span',
            { 'class': Program_style_default.a.tooltipText },
            tooltipText
        )
    );
}

/* harmony default export */ var badge = (badge_Badge);
// CONCATENATED MODULE: ./components/Program/index.js





var Program_Program = function Program(props) {
    var programData = props.programData;
    var description = programData.description;

    return Object(preact_min["h"])(
        "div",
        { "class": Program_style_default.a.program },
        Object(preact_min["h"])(
            "div",
            { "class": Program_style_default.a.col },
            renderProgramTitle(programData),
            renderCallButton(programData)
        ),
        Object(preact_min["h"])(
            "div",
            { "class": Program_style_default.a.col },
            Object(preact_min["h"])(badge, { programData: programData }),
            description
        )
    );
};

function renderProgramTitle(programData) {
    var route_long_name = programData.route_long_name,
        route_url = programData.route_url;

    if (route_url) {
        return Object(preact_min["h"])(
            "h3",
            null,
            Object(preact_min["h"])(
                "a",
                { target: "_blank", href: route_url },
                route_long_name
            )
        );
    }
    return Object(preact_min["h"])(
        "h3",
        null,
        route_long_name
    );
}

function renderCallButton(programData) {
    var phone_number = programData.phone_number;

    if (phone_number) {
        var phoneLink = "tel:1-" + phone_number;
        return Object(preact_min["h"])(
            "a",
            { "class": "btn btn-link", href: phoneLink },
            phone_number
        );
    }
    return '';
}

/* harmony default export */ var components_Program = (Program_Program);
// CONCATENATED MODULE: ./components/ProgramList/index.js


function ProgramList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ProgramList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ProgramList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ProgramList__ref = Object(preact_min["h"])(
    "div",
    { "class": "program-list no-programs" },
    Object(preact_min["h"])(
        "h2",
        { "class": "section-header" },
        Object(preact_min["h"])(
            "span",
            null,
            "It looks like none of our programs fit your search."
        )
    ),
    Object(preact_min["h"])(
        "p",
        { "class": "subtitle" },
        "Check out these other transportation options and see if any fit your needs, or try searching with different criteria."
    )
);

var ProgramList__ref2 = Object(preact_min["h"])(
    "h2",
    { "class": "section-header" },
    Object(preact_min["h"])(
        "span",
        null,
        "After registering with Ride Connection, you can access:"
    )
);

var ProgramList_ProgramList = function (_Component) {
    ProgramList__inherits(ProgramList, _Component);

    function ProgramList() {
        ProgramList__classCallCheck(this, ProgramList);

        return ProgramList__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ProgramList.prototype.render = function render() {
        var _props = this.props,
            formData = _props.formData,
            eligiblePrograms = _props.eligiblePrograms;

        if (Object.keys(formData).length === 0) {
            return '';
        }
        if (eligiblePrograms.length === 0) {
            return ProgramList__ref;
        }
        return Object(preact_min["h"])(
            "div",
            { "class": "program-list" },
            ProgramList__ref2,
            eligiblePrograms.map(function (program) {
                return Object(preact_min["h"])(components_Program, {
                    programData: program,
                    key: program.route_long_name
                });
            })
        );
    };

    return ProgramList;
}(preact_min["Component"]);

/* harmony default export */ var components_ProgramList = (ProgramList_ProgramList);
// EXTERNAL MODULE: ../node_modules/terraformer/terraformer.js
var terraformer = __webpack_require__("jdHL");
var terraformer_default = /*#__PURE__*/__webpack_require__.n(terraformer);

// CONCATENATED MODULE: ./utils/index.js



var utils_calculateProgramBounds = function calculateProgramBounds(areas) {
    var geojson = areas.map(function (area) {
        return area.geojson;
    });
    var areaCollection = new terraformer_default.a.GeometryCollection(geojson);
    var bbox = areaCollection.bbox();
    // BBOX uses lng, lat order. Google uses lat, lng order
    // Let's just name the fields and avoid using order altogether
    return {
        bottom_left: {
            lat: bbox[1],
            lng: bbox[0]
        },
        top_right: {
            lat: bbox[3],
            lng: bbox[2]
        }
    };
};

var DEVELOPER_ID = '85BC2053CC7E3ECD6941E88BD';
var BASE_URL = 'https://developer.trimet.org/ws/V1/stops';
var utils_getNearbyStops = function getNearbyStops(origin, callback) {
    var lnglat = origin.lng.toString() + ',' + origin.lat.toString();
    axios_default.a.get(BASE_URL, {
        params: {
            appID: DEVELOPER_ID,
            json: true,
            ll: lnglat,
            meters: 400
        }
    }).then(function (response) {
        if (response.data && response.data.resultSet && response.data.resultSet.location) {
            console.log(response);
            callback(response.data.resultSet.location.length);
        } else {
            callback(0);
        }
    }).catch(function (error) {
        console.log(error);
        callback(0);
    });
};

var utils_selectActivePrograms = function selectActivePrograms(selectors) {
    var formData = selectors.formData,
        programs = selectors.programs,
        areas = selectors.areas;

    var origin = new terraformer_default.a.Point([formData.origin.lng, formData.origin.lat]);
    if (!formData.eligibility_restricted) {
        programs = programs.filter(function (program) {
            return program.eligibility_restricted === formData.eligibility_restricted;
        });
    }
    programs = programs.filter(function (program) {
        return program.category !== 'alternative';
    });
    programs = programs.filter(function (program) {
        return originIsInProgramBounds(program, areas, origin);
    });
    programs = programs.sort(function (a, b) {
        if (a.category === b.category) return 0;
        if (a.category === 'other') return -1;
        if (b.category === 'other') return 1;
        if (a.category < b.category) return -1;
        if (a.category > b.category) return 1;
    });
    return programs;
};

var selectAlternativePrograms = function selectAlternativePrograms(formData, programs) {
    console.log(formData);
    if (!formData.eligibility_restricted) {
        programs = programs.filter(function (program) {
            return program.eligibility_restricted === formData.eligibility_restricted;
        });
    }
    return programs.filter(function (program) {
        return program.category === 'alternative';
    });
};

function originIsInProgramBounds(program, areas, origin) {
    var found = program.areas.some(function (areaID) {
        var area = areas.find(function (area) {
            return area.area_id == areaID;
        });
        if (area) {
            return area.geojson.contains(origin);
        }
        return false;
    });
    return found;
}
// CONCATENATED MODULE: ./components/AlternativeProgramList/index.js


function AlternativeProgramList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AlternativeProgramList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AlternativeProgramList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AlternativeProgramList__ref = Object(preact_min["h"])(
    "h2",
    { "class": "section-header" },
    Object(preact_min["h"])(
        "span",
        null,
        "Other transportation options"
    )
);

var AlternativeProgramList__ref2 = Object(preact_min["h"])(
    "div",
    { "class": "section-headlines" },
    Object(preact_min["h"])(
        "p",
        null,
        "Ride Connection also sponsors the following transportation programs to help you get around."
    )
);

var AlternativeProgramList_AlternativeProgramList = function (_Component) {
    AlternativeProgramList__inherits(AlternativeProgramList, _Component);

    function AlternativeProgramList() {
        AlternativeProgramList__classCallCheck(this, AlternativeProgramList);

        return AlternativeProgramList__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    AlternativeProgramList.prototype.render = function render() {
        var _props = this.props,
            formData = _props.formData,
            programs = _props.programs;

        if (Object.keys(formData).length === 0) {
            return '';
        }
        var alternativePrograms = selectAlternativePrograms(formData, programs);
        if (alternativePrograms.length === 0) {
            return '';
        }
        return Object(preact_min["h"])(
            "div",
            { "class": "alt-program-list" },
            AlternativeProgramList__ref,
            AlternativeProgramList__ref2,
            alternativePrograms.map(function (program) {
                return Object(preact_min["h"])(components_Program, {
                    programData: program,
                    key: program.route_long_name
                });
            })
        );
    };

    return AlternativeProgramList;
}(preact_min["Component"]);

/* harmony default export */ var components_AlternativeProgramList = (AlternativeProgramList_AlternativeProgramList);
// EXTERNAL MODULE: ./components/StopInfo/style.css
var StopInfo_style = __webpack_require__("eEsx");
var StopInfo_style_default = /*#__PURE__*/__webpack_require__.n(StopInfo_style);

// CONCATENATED MODULE: ./components/StopInfo/index.js




var StopInfo__ref = Object(preact_min["h"])(
    preact_min["Fragment"],
    null,
    'There is ',
    Object(preact_min["h"])(
        'strong',
        null,
        '1 bus stop'
    )
);

var StopInfo__ref2 = Object(preact_min["h"])(
    'p',
    null,
    'If you are unsure of how to take transit, you may be eligible for the ',
    Object(preact_min["h"])(
        'a',
        { target: "_blank", rel: 'noopener noreferrer', href: 'https://rideconnection.org/services/travel-training' },
        'RideWise Travel Training Program'
    ),
    '.'
);

var StopInfo__ref3 = Object(preact_min["h"])(
    'p',
    null,
    'Call Ride Connection at 503-226-0700 or TTY: 7-1-1 (Oregon Relay Service) to learn more about travel training or other services'
);

var StopInfo__ref4 = Object(preact_min["h"])(
    'p',
    null,
    Object(preact_min["h"])(
        'a',
        { target: "_blank", rel: 'noopener noreferrer', href: 'https://trimet.org/lowincome/index.htm' },
        'TriMet\'s Reduced Fare Program'
    )
);

var StopInfo_StopInfo = function StopInfo(props) {
    var nearbyStops = props.nearbyStops,
        stopsLoaded = props.stopsLoaded,
        formData = props.formData;

    if (!stopsLoaded) {
        return '';
    }
    var stopText = void 0;
    if (nearbyStops === 1) {
        stopText = StopInfo__ref;
    } else if (nearbyStops > 1) {
        stopText = Object(preact_min["h"])(
            preact_min["Fragment"],
            null,
            'There are ',
            Object(preact_min["h"])(
                'strong',
                null,
                nearbyStops.toString(),
                ' bus stops'
            )
        );
    } else {
        stopText = 'No bus stops found';
    }
    var trimetURL = 'https://trimet.org/ride/stops_near.html?has_geocode=false&geo_type=place&placeCoord=' + formData.origin.lat + '%2C' + formData.origin.lng + '&place=' + formData.origin.name;
    return Object(preact_min["h"])(
        'div',
        { 'class': StopInfo_style_default.a.stopInfoContainer },
        Object(preact_min["h"])(
            'p',
            null,
            stopText,
            ' within 0.25 miles of your starting address. ',
            Object(preact_min["h"])(
                'a',
                { target: "_blank", rel: 'noopener noreferrer', href: trimetURL },
                'Get directions to the nearest bus stops on the TriMet website.'
            )
        ),
        StopInfo__ref2,
        StopInfo__ref3,
        StopInfo__ref4
    );
};

/* harmony default export */ var components_StopInfo = (StopInfo_StopInfo);
// CONCATENATED MODULE: ./components/Widget.js


function Widget__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Widget__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Widget__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













// props passed in from preact-habitat

var Widget__ref = Object(preact_min["h"])(
    'div',
    { id: 'pf-wrapper' },
    Object(preact_min["h"])(
        'div',
        { 'class': 'spinner rpf-loading' },
        'Loading...'
    )
);

var Widget__ref2 = Object(preact_min["h"])(
    'div',
    { id: 'pf-wrapper' },
    Object(preact_min["h"])(
        'p',
        { 'class': 'error-msg' },
        'Sorry! Looks like there was an error loading the programs.'
    )
);

var Widget_Widget = function (_Component) {
    Widget__inherits(Widget, _Component);

    function Widget() {
        Widget__classCallCheck(this, Widget);

        var _this = Widget__possibleConstructorReturn(this, _Component.call(this));

        _this.state = {
            error: false,
            programs: { loaded: false, data: [] },
            areas: { loaded: false, data: [] },
            formData: {},
            eligiblePrograms: [],
            nearbyStops: null,
            stopsLoaded: false
        };
        _this.bounds = null;
        _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
        return _this;
    }

    Widget.prototype.componentDidMount = function componentDidMount() {
        this.loadPrograms();
        this.loadAreas();
    };

    Widget.prototype.loadPrograms = function loadPrograms() {
        var _this2 = this;

        axios_default.a.get(this.props.programsFile).then(function (response) {
            _this2.setState({
                programs: {
                    loaded: true,
                    data: response.data
                }
            });
        }).catch(function (error) {
            _this2.setState({ error: true });
        });
    };

    Widget.prototype.loadAreas = function loadAreas() {
        var _this3 = this;

        axios_default.a.get(this.props.areasFile, {
            responseType: 'text'
        }).then(function (response) {
            var areasJSON = papaparse_min_default.a.parse(response.data, {
                header: true,
                delimiter: ",",
                skipEmptyLines: true
            });
            var areas = areasJSON.data.map(function (area) {
                return {
                    area_id: area.area_id,
                    geojson: terraformer_wkt_parser_default.a.parse(area.wkt)
                };
            });
            _this3.bounds = utils_calculateProgramBounds(areas);
            _this3.setState({
                areas: {
                    loaded: true,
                    data: areas
                }
            });
        }).catch(function (error) {
            _this3.setState({ error: true });
        });
    };

    Widget.prototype.handleFormSubmit = function handleFormSubmit(formData) {
        var _this4 = this;

        this.setState({ formData: formData });
        var _state = this.state,
            programs = _state.programs,
            areas = _state.areas;

        var eligiblePrograms = utils_selectActivePrograms({
            formData: formData,
            programs: programs.data,
            areas: areas.data
        });
        this.setState({ eligiblePrograms: eligiblePrograms });
        utils_getNearbyStops(formData.origin, function (response) {
            _this4.setState({ nearbyStops: response, stopsLoaded: true });
        });
    };

    Widget.prototype.renderLoading = function renderLoading() {
        return Widget__ref;
    };

    Widget.prototype.renderProgramFinder = function renderProgramFinder() {
        return Object(preact_min["h"])(
            'div',
            { id: 'pf-wrapper' },
            Object(preact_min["h"])(components_Form, {
                handleFormSubmit: this.handleFormSubmit,
                programBounds: this.bounds
            }),
            Object(preact_min["h"])(components_StopInfo, {
                nearbyStops: this.state.nearbyStops,
                stopsLoaded: this.state.stopsLoaded,
                formData: this.state.formData
            }),
            Object(preact_min["h"])(components_ProgramList, {
                programs: this.state.programs.data,
                formData: this.state.formData,
                eligiblePrograms: this.state.eligiblePrograms
            }),
            Object(preact_min["h"])(components_AlternativeProgramList, {
                programs: this.state.programs.data,
                formData: this.state.formData
            })
        );
    };

    Widget.prototype.renderError = function renderError() {
        return Widget__ref2;
    };

    Widget.prototype.render = function render() {
        if (this.state.areas.loaded && this.state.programs.loaded) {
            return this.renderProgramFinder();
        } else if (this.state.error) {
            return this.renderError();
        } else {
            return this.renderLoading();
        }
    };

    return Widget;
}(preact_min["Component"]);

Widget_Widget.defaultProps = {
    programsFile: 'assets/programs.json',
    areasFile: 'assets/areas.txt'
};

/* harmony default export */ var components_Widget = (Widget_Widget);
// CONCATENATED MODULE: ./index.js
var poly = __webpack_require__("m+Gh");






var _habitat = preact_habitat_es(components_Widget);

_habitat.render({
  selector: '#trillium-pf',
  clean: true
});

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "KRuG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");
var settle = __webpack_require__("aS8y");
var cookies = __webpack_require__("dn2M");
var buildURL = __webpack_require__("H6Qo");
var buildFullPath = __webpack_require__("Kxk+");
var parseHeaders = __webpack_require__("ZeD7");
var isURLSameOrigin = __webpack_require__("/w7L");
var createError = __webpack_require__("3bIi");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

/***/ }),

/***/ "Kxk+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__("7/2Y");
var combineURLs = __webpack_require__("a2Uu");

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

/***/ }),

/***/ "M8l6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/***/ }),

/***/ "Ndv3":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, "label{display:inline-block;margin-bottom:0;margin-left:4px}.formField__-7mvw{margin-bottom:12px}.screenReaderText__366-t{border:0;clip:rect(1px,1px,1px,1px);-webkit-clip-path:inset(50%);clip-path:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute!important;width:1px;word-wrap:normal!important}.screenReaderText__366-t:focus{border-radius:3px;-webkit-box-shadow:0 0 2px 2px rgba(0,0,0,.6);box-shadow:0 0 2px 2px rgba(0,0,0,.6);clip:auto!important;-webkit-clip-path:none;clip-path:none;color:palette(mono,darkest);display:block;font-weight:700;height:auto;left:5px;line-height:normal;padding:15px 23px 14px;text-decoration:none;top:5px;width:auto;z-index:100000}.formLegend__2CYtR legend{font-size:2rem;margin-bottom:6px;color:#363a37}.formLegend__2CYtR{margin-bottom:12px}.formLegend__2CYtR input{margin-left:24px;margin-right:4px;vertical-align:middle;display:inline}.formLegend__2CYtR label{display:inline}.optionsSection__MJr85 legend{margin-top:12px;margin-bottom:12px}.optionsSection__MJr85 input{margin-left:24px;display:inline}.optionsSection__MJr85 label{display:inline}.optionsSection__MJr85{overflow:hidden;-webkit-transition:max-height .4s linear;transition:max-height .4s linear}.autoCompleteSection__1_W2x{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:24px}.autoCompleteSection__1_W2x>div:first-child{-webkit-box-flex:1;-ms-flex:1;flex:1;margin-right:24px}.tooltip__1iVUn{display:inline-block;cursor:pointer;position:relative}.tooltip__1iVUn svg{fill:#555;height:1em;width:1em;position:relative;top:3px;left:4px}.tooltipText__cBrJH{border:0;clip:rect(1px,1px,1px,1px);-webkit-clip-path:inset(50%);clip-path:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute!important;width:1px;word-wrap:normal!important}.tooltip__1iVUn:focus div,.tooltip__1iVUn:hover div{border-radius:3px;clip:auto!important;-webkit-clip-path:none;clip-path:none;background-color:#333;color:#fff;font-size:14px;display:block;height:auto;left:25px;line-height:normal;padding:12px;text-decoration:none;top:-14px;width:160px;z-index:100000;font-weight:400}@media (max-width:550px){.optionsSection__MJr85 input{margin-left:0}.optionsSection__MJr85 label{font-size:1.8rem}.autoCompleteSection__1_W2x{display:block;margin-bottom:60px}.autoCompleteSection__1_W2x>div:first-child{margin-right:0;margin-bottom:12px}.autoCompleteSection__1_W2x>div:last-child{text-align:right}}", "", {"version":3,"sources":["/home/rc-program-finder/checkout/rideconnection-program-finder/src/components/Form/style.css"],"names":[],"mappings":"AAAA,MACI,qBAAsB,AACtB,gBAAiB,AACjB,eAAiB,CACpB,AACD,kBACI,kBAAoB,CACvB,AACD,yBACC,SAAU,AACV,2BAA+B,AAC/B,6BAAsB,AAAtB,qBAAsB,AACtB,WAAY,AACZ,YAAa,AACb,gBAAiB,AACjB,UAAW,AACX,4BAA8B,AAC9B,UAAW,AACX,0BAA6B,CAC7B,AAED,+BACI,kBAAmB,AACnB,8CAA2C,AAA3C,sCAA2C,AAC3C,oBAAsB,AACtB,uBAAgB,AAAhB,eAAgB,AAChB,4BAA8B,AAC9B,cAAe,AACf,gBAAkB,AAClB,YAAa,AACb,SAAU,AACV,mBAAoB,AACpB,uBAAwB,AACxB,qBAAsB,AACtB,QAAS,AACT,WAAY,AACZ,cAAgB,CACnB,AAED,0BACI,eAAgB,AAChB,kBAAmB,AACnB,aAAe,CAClB,AACD,mBACI,kBAAoB,CACvB,AACD,yBACI,iBAAkB,AAClB,iBAAkB,AAClB,sBAAuB,AACvB,cAAgB,CACnB,AACD,yBACI,cAAgB,CACnB,AAED,8BACI,gBAAiB,AACjB,kBAAoB,CACvB,AACD,6BACI,iBAAkB,AAClB,cAAgB,CACnB,AACD,6BACI,cAAgB,CACnB,AACD,uBACI,gBAAiB,AACjB,yCAAmC,AAAnC,gCAAmC,CACtC,AACD,4BACI,oBAAc,AAAd,oBAAc,AAAd,aAAc,AACd,yBAA+B,AAA/B,sBAA+B,AAA/B,8BAA+B,AAC/B,yBAAoB,AAApB,sBAAoB,AAApB,mBAAoB,AACpB,kBAAoB,CACvB,AACD,4CACI,mBAAQ,AAAR,WAAQ,AAAR,OAAQ,AACR,iBAAmB,CACtB,AACD,gBACI,qBAAsB,AACtB,eAAgB,AAChB,iBAAmB,CACtB,AACD,oBACI,UAAW,AACX,WAAY,AACZ,UAAW,AACX,kBAAmB,AACnB,QAAS,AACT,QAAU,CACb,AACD,oBACI,SAAU,AACb,2BAA+B,AAC/B,6BAAsB,AAAtB,qBAAsB,AACtB,WAAY,AACZ,YAAa,AACb,gBAAiB,AACjB,UAAW,AACX,4BAA8B,AAC9B,UAAW,AACX,0BAA6B,CAC7B,AACD,oDAEI,kBAAmB,AACnB,oBAAsB,AACtB,uBAAgB,AAAhB,eAAgB,AAChB,sBAAuB,AACvB,WAAY,AACZ,eAAgB,AAChB,cAAe,AACf,YAAa,AACb,UAAW,AACX,mBAAoB,AACpB,aAAc,AACd,qBAAsB,AACtB,UAAW,AACX,YAAa,AACb,eAAgB,AAChB,eAAiB,CACpB,AACD,yBACI,6BACI,aAAe,CAClB,AACD,6BACI,gBAAkB,CACrB,AACD,4BACI,cAAe,AACf,kBAAoB,CACvB,AACD,4CACI,eAAgB,AAChB,kBAAoB,CACvB,AACD,2CACI,gBAAkB,CACrB,CAEJ","file":"style.css","sourcesContent":["label {\n    display: inline-block;\n    margin-bottom: 0;\n    margin-left: 4px;\n}\n.formField {\n    margin-bottom: 12px;\n}\n.screenReaderText {\n\tborder: 0;\n\tclip: rect(1px, 1px, 1px, 1px);\n\tclip-path: inset(50%);\n\theight: 1px;\n\tmargin: -1px;\n\toverflow: hidden;\n\tpadding: 0;\n\tposition: absolute !important;\n\twidth: 1px;\n\tword-wrap: normal !important;\n}\n\n.screenReaderText:focus {\n    border-radius: 3px;\n    box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.6);\n    clip: auto !important;\n    clip-path: none;\n    color: palette(mono, darkest);\n    display: block;\n    font-weight: bold;\n    height: auto;\n    left: 5px;\n    line-height: normal;\n    padding: 15px 23px 14px;\n    text-decoration: none;\n    top: 5px;\n    width: auto;\n    z-index: 100000;\n}\n\n.formLegend legend {\n    font-size: 2rem;\n    margin-bottom: 6px;\n    color: #363a37;\n}\n.formLegend {\n    margin-bottom: 12px;\n}\n.formLegend input {\n    margin-left: 24px;\n    margin-right: 4px;\n    vertical-align: middle;\n    display: inline;\n}\n.formLegend label {\n    display: inline;\n}\n\n.optionsSection legend {\n    margin-top: 12px;\n    margin-bottom: 12px;\n}\n.optionsSection input {\n    margin-left: 24px;\n    display: inline;\n}\n.optionsSection label {\n    display: inline;\n}\n.optionsSection {\n    overflow: hidden;\n    transition: max-height 0.4s linear;\n}\n.autoCompleteSection {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n}\n.autoCompleteSection > div:first-child {\n    flex: 1;\n    margin-right: 24px;\n}\n.tooltip {\n    display: inline-block;\n    cursor: pointer;\n    position: relative;\n}\n.tooltip svg {\n    fill: #555;\n    height: 1em;\n    width: 1em;\n    position: relative;\n    top: 3px;\n    left: 4px;\n}\n.tooltipText {\n    border: 0;\n\tclip: rect(1px, 1px, 1px, 1px);\n\tclip-path: inset(50%);\n\theight: 1px;\n\tmargin: -1px;\n\toverflow: hidden;\n\tpadding: 0;\n\tposition: absolute !important;\n\twidth: 1px;\n\tword-wrap: normal !important;\n}\n.tooltip:hover div,\n.tooltip:focus div {\n    border-radius: 3px;\n    clip: auto !important;\n    clip-path: none;\n    background-color: #333;\n    color: #fff;\n    font-size: 14px;\n    display: block;\n    height: auto;\n    left: 25px;\n    line-height: normal;\n    padding: 12px;\n    text-decoration: none;\n    top: -14px;\n    width: 160px;\n    z-index: 100000;\n    font-weight: 400;\n}\n@media (max-width: 550px) {\n    .optionsSection input {\n        margin-left: 0;\n    }\n    .optionsSection label {\n        font-size: 1.8rem;\n    }\n    .autoCompleteSection{\n        display: block;\n        margin-bottom: 60px;\n    }\n    .autoCompleteSection > div:first-child {\n        margin-right: 0;\n        margin-bottom: 12px;\n    }\n    .autoCompleteSection > div:last-child {\n        text-align: right;\n    }\n\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"formField": "formField__-7mvw",
	"screenReaderText": "screenReaderText__366-t",
	"formLegend": "formLegend__2CYtR",
	"optionsSection": "optionsSection__MJr85",
	"autoCompleteSection": "autoCompleteSection__1_W2x",
	"tooltip": "tooltip__1iVUn",
	"tooltipText": "tooltipText__cBrJH"
};

/***/ }),

/***/ "OvAf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");
var buildURL = __webpack_require__("H6Qo");
var InterceptorManager = __webpack_require__("rj2i");
var dispatchRequest = __webpack_require__("uz6X");
var mergeConfig = __webpack_require__("2OHv");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

/***/ }),

/***/ "QAmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var index = typeof fetch == 'function' ? fetch.bind() : function (url, options) {
	options = options || {};
	return new Promise(function (resolve, reject) {
		var request = new XMLHttpRequest();

		request.open(options.method || 'get', url, true);

		for (var i in options.headers) {
			request.setRequestHeader(i, options.headers[i]);
		}

		request.withCredentials = options.credentials == 'include';

		request.onload = function () {
			resolve(response());
		};

		request.onerror = reject;

		request.send(options.body || null);

		function response() {
			var _keys = [],
			    all = [],
			    headers = {},
			    header;

			request.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (m, key, value) {
				_keys.push(key = key.toLowerCase());
				all.push([key, value]);
				header = headers[key];
				headers[key] = header ? header + "," + value : value;
			});

			return {
				ok: (request.status / 100 | 0) == 2, // 200-299
				status: request.status,
				statusText: request.statusText,
				url: request.responseURL,
				clone: response,
				text: function text() {
					return Promise.resolve(request.responseText);
				},
				json: function json() {
					return Promise.resolve(request.responseText).then(JSON.parse);
				},
				blob: function blob() {
					return Promise.resolve(new Blob([request.response]));
				},
				headers: {
					keys: function keys() {
						return _keys;
					},
					entries: function entries() {
						return all;
					},
					get: function get(n) {
						return headers[n.toLowerCase()];
					},
					has: function has(n) {
						return n.toLowerCase() in headers;
					}
				}
			};
		}
	});
};

/* harmony default export */ __webpack_exports__["default"] = (index);
//# sourceMappingURL=unfetch.es.js.map

/***/ }),

/***/ "S1cf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("ED/T");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
    return false;
  }
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge() /* obj1, obj2, obj3, ... */{
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

/***/ }),

/***/ "UJLu":
/***/ (function(module, exports, __webpack_require__) {

(function (root, factory) {

  // Node.
  if (typeof module === 'object' && typeof module.exports === 'object') {
    exports = module.exports = factory(__webpack_require__("jdHL"));
  } else if (typeof navigator === "object") {
    // Browser Global.
    if (!root.Terraformer) {
      throw new Error("Terraformer.WKT requires the core Terraformer library. http://github.com/esri/terraformer");
    }
    root.Terraformer.WKT = factory(root.Terraformer);
  }
})(this, function (Terraformer) {
  var exports = {};

  /* Jison generated parser */
  var parser = function () {
    var parser = { trace: function trace() {},
      yy: {},
      symbols_: { "error": 2, "expressions": 3, "point": 4, "EOF": 5, "linestring": 6, "polygon": 7, "multipoint": 8, "multilinestring": 9, "multipolygon": 10, "coordinate": 11, "DOUBLE_TOK": 12, "ptarray": 13, "COMMA": 14, "ring_list": 15, "ring": 16, "(": 17, ")": 18, "POINT": 19, "Z": 20, "ZM": 21, "M": 22, "EMPTY": 23, "point_untagged": 24, "polygon_list": 25, "polygon_untagged": 26, "point_list": 27, "LINESTRING": 28, "POLYGON": 29, "MULTIPOINT": 30, "MULTILINESTRING": 31, "MULTIPOLYGON": 32, "$accept": 0, "$end": 1 },
      terminals_: { 2: "error", 5: "EOF", 12: "DOUBLE_TOK", 14: "COMMA", 17: "(", 18: ")", 19: "POINT", 20: "Z", 21: "ZM", 22: "M", 23: "EMPTY", 28: "LINESTRING", 29: "POLYGON", 30: "MULTIPOINT", 31: "MULTILINESTRING", 32: "MULTIPOLYGON" },
      productions_: [0, [3, 2], [3, 2], [3, 2], [3, 2], [3, 2], [3, 2], [11, 2], [11, 3], [11, 4], [13, 3], [13, 1], [15, 3], [15, 1], [16, 3], [4, 4], [4, 5], [4, 5], [4, 5], [4, 2], [24, 1], [24, 3], [25, 3], [25, 1], [26, 3], [27, 3], [27, 1], [6, 4], [6, 5], [6, 5], [6, 5], [6, 2], [7, 4], [7, 5], [7, 5], [7, 5], [7, 2], [8, 4], [8, 5], [8, 5], [8, 5], [8, 2], [9, 4], [9, 5], [9, 5], [9, 5], [9, 2], [10, 4], [10, 5], [10, 5], [10, 5], [10, 2]],
      performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $, _$) {

        var $0 = $.length - 1;
        switch (yystate) {
          case 1:
            return $[$0 - 1];
            break;
          case 2:
            return $[$0 - 1];
            break;
          case 3:
            return $[$0 - 1];
            break;
          case 4:
            return $[$0 - 1];
            break;
          case 5:
            return $[$0 - 1];
            break;
          case 6:
            return $[$0 - 1];
            break;
          case 7:
            this.$ = new PointArray([Number($[$0 - 1]), Number($[$0])]);
            break;
          case 8:
            this.$ = new PointArray([Number($[$0 - 2]), Number($[$0 - 1]), Number($[$0])]);
            break;
          case 9:
            this.$ = new PointArray([Number($[$0 - 3]), Number($[$0 - 2]), Number($[$0 - 1]), Number($[$0])]);
            break;
          case 10:
            this.$ = $[$0 - 2].addPoint($[$0]);
            break;
          case 11:
            this.$ = $[$0];
            break;
          case 12:
            this.$ = $[$0 - 2].addRing($[$0]);
            break;
          case 13:
            this.$ = new RingList($[$0]);
            break;
          case 14:
            this.$ = new Ring($[$0 - 1]);
            break;
          case 15:
            this.$ = { "type": "Point", "coordinates": $[$0 - 1].data[0] };
            break;
          case 16:
            this.$ = { "type": "Point", "coordinates": $[$0 - 1].data[0], "properties": { z: true } };
            break;
          case 17:
            this.$ = { "type": "Point", "coordinates": $[$0 - 1].data[0], "properties": { z: true, m: true } };
            break;
          case 18:
            this.$ = { "type": "Point", "coordinates": $[$0 - 1].data[0], "properties": { m: true } };
            break;
          case 19:
            this.$ = { "type": "Point", "coordinates": [] };
            break;
          case 20:
            this.$ = $[$0];
            break;
          case 21:
            this.$ = $[$0 - 1];
            break;
          case 22:
            this.$ = $[$0 - 2].addPolygon($[$0]);
            break;
          case 23:
            this.$ = new PolygonList($[$0]);
            break;
          case 24:
            this.$ = $[$0 - 1];
            break;
          case 25:
            this.$ = $[$0 - 2].addPoint($[$0]);
            break;
          case 26:
            this.$ = $[$0];
            break;
          case 27:
            this.$ = { "type": "LineString", "coordinates": $[$0 - 1].data };
            break;
          case 28:
            this.$ = { "type": "LineString", "coordinates": $[$0 - 1].data, "properties": { z: true } };
            break;
          case 29:
            this.$ = { "type": "LineString", "coordinates": $[$0 - 1].data, "properties": { m: true } };
            break;
          case 30:
            this.$ = { "type": "LineString", "coordinates": $[$0 - 1].data, "properties": { z: true, m: true } };
            break;
          case 31:
            this.$ = { "type": "LineString", "coordinates": [] };
            break;
          case 32:
            this.$ = { "type": "Polygon", "coordinates": $[$0 - 1].toJSON() };
            break;
          case 33:
            this.$ = { "type": "Polygon", "coordinates": $[$0 - 1].toJSON(), "properties": { z: true } };
            break;
          case 34:
            this.$ = { "type": "Polygon", "coordinates": $[$0 - 1].toJSON(), "properties": { m: true } };
            break;
          case 35:
            this.$ = { "type": "Polygon", "coordinates": $[$0 - 1].toJSON(), "properties": { z: true, m: true } };
            break;
          case 36:
            this.$ = { "type": "Polygon", "coordinates": [] };
            break;
          case 37:
            this.$ = { "type": "MultiPoint", "coordinates": $[$0 - 1].data };
            break;
          case 38:
            this.$ = { "type": "MultiPoint", "coordinates": $[$0 - 1].data, "properties": { z: true } };
            break;
          case 39:
            this.$ = { "type": "MultiPoint", "coordinates": $[$0 - 1].data, "properties": { m: true } };
            break;
          case 40:
            this.$ = { "type": "MultiPoint", "coordinates": $[$0 - 1].data, "properties": { z: true, m: true } };
            break;
          case 41:
            this.$ = { "type": "MultiPoint", "coordinates": [] };
            break;
          case 42:
            this.$ = { "type": "MultiLineString", "coordinates": $[$0 - 1].toJSON() };
            break;
          case 43:
            this.$ = { "type": "MultiLineString", "coordinates": $[$0 - 1].toJSON(), "properties": { z: true } };
            break;
          case 44:
            this.$ = { "type": "MultiLineString", "coordinates": $[$0 - 1].toJSON(), "properties": { m: true } };
            break;
          case 45:
            this.$ = { "type": "MultiLineString", "coordinates": $[$0 - 1].toJSON(), "properties": { z: true, m: true } };
            break;
          case 46:
            this.$ = { "type": "MultiLineString", "coordinates": [] };
            break;
          case 47:
            this.$ = { "type": "MultiPolygon", "coordinates": $[$0 - 1].toJSON() };
            break;
          case 48:
            this.$ = { "type": "MultiPolygon", "coordinates": $[$0 - 1].toJSON(), "properties": { z: true } };
            break;
          case 49:
            this.$ = { "type": "MultiPolygon", "coordinates": $[$0 - 1].toJSON(), "properties": { m: true } };
            break;
          case 50:
            this.$ = { "type": "MultiPolygon", "coordinates": $[$0 - 1].toJSON(), "properties": { z: true, m: true } };
            break;
          case 51:
            this.$ = { "type": "MultiPolygon", "coordinates": [] };
            break;
        }
      },
      table: [{ 3: 1, 4: 2, 6: 3, 7: 4, 8: 5, 9: 6, 10: 7, 19: [1, 8], 28: [1, 9], 29: [1, 10], 30: [1, 11], 31: [1, 12], 32: [1, 13] }, { 1: [3] }, { 5: [1, 14] }, { 5: [1, 15] }, { 5: [1, 16] }, { 5: [1, 17] }, { 5: [1, 18] }, { 5: [1, 19] }, { 17: [1, 20], 20: [1, 21], 21: [1, 22], 22: [1, 23], 23: [1, 24] }, { 17: [1, 25], 20: [1, 26], 21: [1, 28], 22: [1, 27], 23: [1, 29] }, { 17: [1, 30], 20: [1, 31], 21: [1, 33], 22: [1, 32], 23: [1, 34] }, { 17: [1, 35], 20: [1, 36], 21: [1, 38], 22: [1, 37], 23: [1, 39] }, { 17: [1, 40], 20: [1, 41], 21: [1, 43], 22: [1, 42], 23: [1, 44] }, { 17: [1, 45], 20: [1, 46], 21: [1, 48], 22: [1, 47], 23: [1, 49] }, { 1: [2, 1] }, { 1: [2, 2] }, { 1: [2, 3] }, { 1: [2, 4] }, { 1: [2, 5] }, { 1: [2, 6] }, { 11: 51, 12: [1, 52], 13: 50 }, { 17: [1, 53] }, { 17: [1, 54] }, { 17: [1, 55] }, { 5: [2, 19] }, { 11: 58, 12: [1, 52], 17: [1, 59], 24: 57, 27: 56 }, { 17: [1, 60] }, { 17: [1, 61] }, { 17: [1, 62] }, { 5: [2, 31] }, { 15: 63, 16: 64, 17: [1, 65] }, { 17: [1, 66] }, { 17: [1, 67] }, { 17: [1, 68] }, { 5: [2, 36] }, { 11: 58, 12: [1, 52], 17: [1, 59], 24: 57, 27: 69 }, { 17: [1, 70] }, { 17: [1, 71] }, { 17: [1, 72] }, { 5: [2, 41] }, { 15: 73, 16: 64, 17: [1, 65] }, { 17: [1, 74] }, { 17: [1, 75] }, { 17: [1, 76] }, { 5: [2, 46] }, { 17: [1, 79], 25: 77, 26: 78 }, { 17: [1, 80] }, { 17: [1, 81] }, { 17: [1, 82] }, { 5: [2, 51] }, { 14: [1, 84], 18: [1, 83] }, { 14: [2, 11], 18: [2, 11] }, { 12: [1, 85] }, { 11: 51, 12: [1, 52], 13: 86 }, { 11: 51, 12: [1, 52], 13: 87 }, { 11: 51, 12: [1, 52], 13: 88 }, { 14: [1, 90], 18: [1, 89] }, { 14: [2, 26], 18: [2, 26] }, { 14: [2, 20], 18: [2, 20] }, { 11: 91, 12: [1, 52] }, { 11: 58, 12: [1, 52], 17: [1, 59], 24: 57, 27: 92 }, { 11: 58, 12: [1, 52], 17: [1, 59], 24: 57, 27: 93 }, { 11: 58, 12: [1, 52], 17: [1, 59], 24: 57, 27: 94 }, { 14: [1, 96], 18: [1, 95] }, { 14: [2, 13], 18: [2, 13] }, { 11: 51, 12: [1, 52], 13: 97 }, { 15: 98, 16: 64, 17: [1, 65] }, { 15: 99, 16: 64, 17: [1, 65] }, { 15: 100, 16: 64, 17: [1, 65] }, { 14: [1, 90], 18: [1, 101] }, { 11: 58, 12: [1, 52], 17: [1, 59], 24: 57, 27: 102 }, { 11: 58, 12: [1, 52], 17: [1, 59], 24: 57, 27: 103 }, { 11: 58, 12: [1, 52], 17: [1, 59], 24: 57, 27: 104 }, { 14: [1, 96], 18: [1, 105] }, { 15: 106, 16: 64, 17: [1, 65] }, { 15: 107, 16: 64, 17: [1, 65] }, { 15: 108, 16: 64, 17: [1, 65] }, { 14: [1, 110], 18: [1, 109] }, { 14: [2, 23], 18: [2, 23] }, { 15: 111, 16: 64, 17: [1, 65] }, { 17: [1, 79], 25: 112, 26: 78 }, { 17: [1, 79], 25: 113, 26: 78 }, { 17: [1, 79], 25: 114, 26: 78 }, { 5: [2, 15] }, { 11: 115, 12: [1, 52] }, { 12: [1, 116], 14: [2, 7], 18: [2, 7] }, { 14: [1, 84], 18: [1, 117] }, { 14: [1, 84], 18: [1, 118] }, { 14: [1, 84], 18: [1, 119] }, { 5: [2, 27] }, { 11: 58, 12: [1, 52], 17: [1, 59], 24: 120 }, { 18: [1, 121] }, { 14: [1, 90], 18: [1, 122] }, { 14: [1, 90], 18: [1, 123] }, { 14: [1, 90], 18: [1, 124] }, { 5: [2, 32] }, { 16: 125, 17: [1, 65] }, { 14: [1, 84], 18: [1, 126] }, { 14: [1, 96], 18: [1, 127] }, { 14: [1, 96], 18: [1, 128] }, { 14: [1, 96], 18: [1, 129] }, { 5: [2, 37] }, { 14: [1, 90], 18: [1, 130] }, { 14: [1, 90], 18: [1, 131] }, { 14: [1, 90], 18: [1, 132] }, { 5: [2, 42] }, { 14: [1, 96], 18: [1, 133] }, { 14: [1, 96], 18: [1, 134] }, { 14: [1, 96], 18: [1, 135] }, { 5: [2, 47] }, { 17: [1, 79], 26: 136 }, { 14: [1, 96], 18: [1, 137] }, { 14: [1, 110], 18: [1, 138] }, { 14: [1, 110], 18: [1, 139] }, { 14: [1, 110], 18: [1, 140] }, { 14: [2, 10], 18: [2, 10] }, { 12: [1, 141], 14: [2, 8], 18: [2, 8] }, { 5: [2, 16] }, { 5: [2, 17] }, { 5: [2, 18] }, { 14: [2, 25], 18: [2, 25] }, { 14: [2, 21], 18: [2, 21] }, { 5: [2, 28] }, { 5: [2, 29] }, { 5: [2, 30] }, { 14: [2, 12], 18: [2, 12] }, { 14: [2, 14], 18: [2, 14] }, { 5: [2, 33] }, { 5: [2, 34] }, { 5: [2, 35] }, { 5: [2, 38] }, { 5: [2, 39] }, { 5: [2, 40] }, { 5: [2, 43] }, { 5: [2, 44] }, { 5: [2, 45] }, { 14: [2, 22], 18: [2, 22] }, { 14: [2, 24], 18: [2, 24] }, { 5: [2, 48] }, { 5: [2, 49] }, { 5: [2, 50] }, { 14: [2, 9], 18: [2, 9] }],
      defaultActions: { 14: [2, 1], 15: [2, 2], 16: [2, 3], 17: [2, 4], 18: [2, 5], 19: [2, 6], 24: [2, 19], 29: [2, 31], 34: [2, 36], 39: [2, 41], 44: [2, 46], 49: [2, 51], 83: [2, 15], 89: [2, 27], 95: [2, 32], 101: [2, 37], 105: [2, 42], 109: [2, 47], 117: [2, 16], 118: [2, 17], 119: [2, 18], 122: [2, 28], 123: [2, 29], 124: [2, 30], 127: [2, 33], 128: [2, 34], 129: [2, 35], 130: [2, 38], 131: [2, 39], 132: [2, 40], 133: [2, 43], 134: [2, 44], 135: [2, 45], 138: [2, 48], 139: [2, 49], 140: [2, 50] },
      parseError: function parseError(str, hash) {
        throw new Error(str);
      },
      parse: function parse(input) {
        var self = this,
            stack = [0],
            vstack = [null],
            lstack = [],
            table = this.table,
            yytext = "",
            yylineno = 0,
            yyleng = 0,
            recovering = 0,
            TERROR = 2,
            EOF = 1;
        this.lexer.setInput(input);
        this.lexer.yy = this.yy;
        this.yy.lexer = this.lexer;
        this.yy.parser = this;
        if (typeof this.lexer.yylloc == "undefined") this.lexer.yylloc = {};
        var yyloc = this.lexer.yylloc;
        lstack.push(yyloc);
        var ranges = this.lexer.options && this.lexer.options.ranges;
        if (typeof this.yy.parseError === "function") this.parseError = this.yy.parseError;
        function popStack(n) {
          stack.length = stack.length - 2 * n;
          vstack.length = vstack.length - n;
          lstack.length = lstack.length - n;
        }
        function lex() {
          var token;
          token = self.lexer.lex() || 1;
          if (typeof token !== "number") {
            token = self.symbols_[token] || token;
          }
          return token;
        }
        var symbol,
            preErrorSymbol,
            state,
            action,
            a,
            r,
            yyval = {},
            p,
            len,
            newState,
            expected;
        while (true) {
          state = stack[stack.length - 1];
          if (this.defaultActions[state]) {
            action = this.defaultActions[state];
          } else {
            if (symbol === null || typeof symbol == "undefined") {
              symbol = lex();
            }
            action = table[state] && table[state][symbol];
          }
          if (typeof action === "undefined" || !action.length || !action[0]) {
            var errStr = "";
            if (!recovering) {
              expected = [];
              for (p in table[state]) {
                if (this.terminals_[p] && p > 2) {
                  expected.push("'" + this.terminals_[p] + "'");
                }
              }if (this.lexer.showPosition) {
                errStr = "Parse error on line " + (yylineno + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
              } else {
                errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == 1 ? "end of input" : "'" + (this.terminals_[symbol] || symbol) + "'");
              }
              this.parseError(errStr, { text: this.lexer.match, token: this.terminals_[symbol] || symbol, line: this.lexer.yylineno, loc: yyloc, expected: expected });
            }
          }
          if (action[0] instanceof Array && action.length > 1) {
            throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
          }
          switch (action[0]) {
            case 1:
              stack.push(symbol);
              vstack.push(this.lexer.yytext);
              lstack.push(this.lexer.yylloc);
              stack.push(action[1]);
              symbol = null;
              if (!preErrorSymbol) {
                yyleng = this.lexer.yyleng;
                yytext = this.lexer.yytext;
                yylineno = this.lexer.yylineno;
                yyloc = this.lexer.yylloc;
                if (recovering > 0) recovering--;
              } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
              }
              break;
            case 2:
              len = this.productions_[action[1]][1];
              yyval.$ = vstack[vstack.length - len];
              yyval._$ = { first_line: lstack[lstack.length - (len || 1)].first_line, last_line: lstack[lstack.length - 1].last_line, first_column: lstack[lstack.length - (len || 1)].first_column, last_column: lstack[lstack.length - 1].last_column };
              if (ranges) {
                yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
              }
              r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);
              if (typeof r !== "undefined") {
                return r;
              }
              if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
              }
              stack.push(this.productions_[action[1]][0]);
              vstack.push(yyval.$);
              lstack.push(yyval._$);
              newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
              stack.push(newState);
              break;
            case 3:
              return true;
          }
        }
        return true;
      }
    };
    undefined; /* Jison generated lexer */
    var lexer = function () {
      var lexer = { EOF: 1,
        parseError: function parseError(str, hash) {
          if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
          } else {
            throw new Error(str);
          }
        },
        setInput: function setInput(input) {
          this._input = input;
          this._more = this._less = this.done = false;
          this.yylineno = this.yyleng = 0;
          this.yytext = this.matched = this.match = '';
          this.conditionStack = ['INITIAL'];
          this.yylloc = { first_line: 1, first_column: 0, last_line: 1, last_column: 0 };
          if (this.options.ranges) this.yylloc.range = [0, 0];
          this.offset = 0;
          return this;
        },
        input: function input() {
          var ch = this._input[0];
          this.yytext += ch;
          this.yyleng++;
          this.offset++;
          this.match += ch;
          this.matched += ch;
          var lines = ch.match(/(?:\r\n?|\n).*/g);
          if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
          } else {
            this.yylloc.last_column++;
          }
          if (this.options.ranges) this.yylloc.range[1]++;

          this._input = this._input.slice(1);
          return ch;
        },
        unput: function unput(ch) {
          var len = ch.length;
          var lines = ch.split(/(?:\r\n?|\n)/g);

          this._input = ch + this._input;
          this.yytext = this.yytext.substr(0, this.yytext.length - len - 1);
          //this.yyleng -= len;
          this.offset -= len;
          var oldLines = this.match.split(/(?:\r\n?|\n)/g);
          this.match = this.match.substr(0, this.match.length - 1);
          this.matched = this.matched.substr(0, this.matched.length - 1);

          if (lines.length - 1) this.yylineno -= lines.length - 1;
          var r = this.yylloc.range;

          this.yylloc = { first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
          };

          if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
          }
          return this;
        },
        more: function more() {
          this._more = true;
          return this;
        },
        less: function less(n) {
          this.unput(this.match.slice(n));
        },
        pastInput: function pastInput() {
          var past = this.matched.substr(0, this.matched.length - this.match.length);
          return (past.length > 20 ? '...' : '') + past.substr(-20).replace(/\n/g, "");
        },
        upcomingInput: function upcomingInput() {
          var next = this.match;
          if (next.length < 20) {
            next += this._input.substr(0, 20 - next.length);
          }
          return (next.substr(0, 20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
        },
        showPosition: function showPosition() {
          var pre = this.pastInput();
          var c = new Array(pre.length + 1).join("-");
          return pre + this.upcomingInput() + "\n" + c + "^";
        },
        next: function next() {
          if (this.done) {
            return this.EOF;
          }
          if (!this._input) this.done = true;

          var token, match, tempMatch, index, col, lines;
          if (!this._more) {
            this.yytext = '';
            this.match = '';
          }
          var rules = this._currentRules();
          for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
              match = tempMatch;
              index = i;
              if (!this.options.flex) break;
            }
          }
          if (match) {
            lines = match[0].match(/(?:\r\n?|\n).*/g);
            if (lines) this.yylineno += lines.length;
            this.yylloc = { first_line: this.yylloc.last_line,
              last_line: this.yylineno + 1,
              first_column: this.yylloc.last_column,
              last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length };
            this.yytext += match[0];
            this.match += match[0];
            this.matches = match;
            this.yyleng = this.yytext.length;
            if (this.options.ranges) {
              this.yylloc.range = [this.offset, this.offset += this.yyleng];
            }
            this._more = false;
            this._input = this._input.slice(match[0].length);
            this.matched += match[0];
            token = this.performAction.call(this, this.yy, this, rules[index], this.conditionStack[this.conditionStack.length - 1]);
            if (this.done && this._input) this.done = false;
            if (token) return token;else return;
          }
          if (this._input === "") {
            return this.EOF;
          } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), { text: "", token: null, line: this.yylineno });
          }
        },
        lex: function lex() {
          var r = this.next();
          if (typeof r !== 'undefined') {
            return r;
          } else {
            return this.lex();
          }
        },
        begin: function begin(condition) {
          this.conditionStack.push(condition);
        },
        popState: function popState() {
          return this.conditionStack.pop();
        },
        _currentRules: function _currentRules() {
          return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        },
        topState: function topState() {
          return this.conditionStack[this.conditionStack.length - 2];
        },
        pushState: function begin(condition) {
          this.begin(condition);
        } };
      lexer.options = {};
      lexer.performAction = function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {

        var YYSTATE = YY_START;
        switch ($avoiding_name_collisions) {
          case 0:
            // ignore
            break;
          case 1:
            return 17;
            break;
          case 2:
            return 18;
            break;
          case 3:
            return 12;
            break;
          case 4:
            return 19;
            break;
          case 5:
            return 28;
            break;
          case 6:
            return 29;
            break;
          case 7:
            return 30;
            break;
          case 8:
            return 31;
            break;
          case 9:
            return 32;
            break;
          case 10:
            return 14;
            break;
          case 11:
            return 23;
            break;
          case 12:
            return 22;
            break;
          case 13:
            return 20;
            break;
          case 14:
            return 21;
            break;
          case 15:
            return 5;
            break;
          case 16:
            return "INVALID";
            break;
        }
      };
      lexer.rules = [/^(?:\s+)/, /^(?:\()/, /^(?:\))/, /^(?:-?[0-9]+(\.[0-9]+)?([eE][\-\+]?[0-9]+)?)/, /^(?:POINT\b)/, /^(?:LINESTRING\b)/, /^(?:POLYGON\b)/, /^(?:MULTIPOINT\b)/, /^(?:MULTILINESTRING\b)/, /^(?:MULTIPOLYGON\b)/, /^(?:,)/, /^(?:EMPTY\b)/, /^(?:M\b)/, /^(?:Z\b)/, /^(?:ZM\b)/, /^(?:$)/, /^(?:.)/];
      lexer.conditions = { "INITIAL": { "rules": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16], "inclusive": true } };
      return lexer;
    }();
    parser.lexer = lexer;
    function Parser() {
      this.yy = {};
    }Parser.prototype = parser;parser.Parser = Parser;
    return new Parser();
  }();

  function PointArray(point) {
    this.data = [point];
    this.type = 'PointArray';
  }

  PointArray.prototype.addPoint = function (point) {
    if (point.type === 'PointArray') {
      this.data = this.data.concat(point.data);
    } else {
      this.data.push(point);
    }

    return this;
  };

  PointArray.prototype.toJSON = function () {
    return this.data;
  };

  function Ring(point) {
    this.data = point;
    this.type = 'Ring';
  }

  Ring.prototype.toJSON = function () {
    var data = [];

    for (var i = 0; i < this.data.data.length; i++) {
      data.push(this.data.data[i]);
    }

    return data;
  };

  function RingList(ring) {
    this.data = [ring];
    this.type = 'RingList';
  }

  RingList.prototype.addRing = function (ring) {
    this.data.push(ring);

    return this;
  };

  RingList.prototype.toJSON = function () {
    var data = [];

    for (var i = 0; i < this.data.length; i++) {
      data.push(this.data[i].toJSON());
    }

    if (data.length === 1) {
      return data;
    } else {
      return data;
    }
  };

  function PolygonList(polygon) {
    this.data = [polygon];
    this.type = 'PolygonList';
  }

  PolygonList.prototype.addPolygon = function (polygon) {
    this.data.push(polygon);

    return this;
  };

  PolygonList.prototype.toJSON = function () {
    var data = [];

    for (var i = 0; i < this.data.length; i++) {
      data = data.concat([this.data[i].toJSON()]);
    }

    return data;
  };

  function _parse() {
    return parser.parse.apply(parser, arguments);
  }

  function parse(element) {
    var res, primitive;

    try {
      res = parser.parse(element);
    } catch (err) {
      throw Error("Unable to parse: " + err);
    }

    return Terraformer.Primitive(res);
  }

  function arrayToRing(arr) {
    var parts = [],
        ret = '';

    for (var i = 0; i < arr.length; i++) {
      parts.push(arr[i].join(' '));
    }

    ret += '(' + parts.join(', ') + ')';

    return ret;
  }

  function pointToWKTPoint(primitive) {
    var ret = 'POINT ';

    if (primitive.coordinates === undefined || primitive.coordinates.length === 0) {
      ret += 'EMPTY';

      return ret;
    } else if (primitive.coordinates.length === 3) {
      // 3d or time? default to 3d
      if (primitive.properties && primitive.properties.m === true) {
        ret += 'M ';
      } else {
        ret += 'Z ';
      }
    } else if (primitive.coordinates.length === 4) {
      // 3d and time
      ret += 'ZM ';
    }

    // include coordinates
    ret += '(' + primitive.coordinates.join(' ') + ')';

    return ret;
  }

  function lineStringToWKTLineString(primitive) {
    var ret = 'LINESTRING ';

    if (primitive.coordinates === undefined || primitive.coordinates.length === 0 || primitive.coordinates[0].length === 0) {
      ret += 'EMPTY';

      return ret;
    } else if (primitive.coordinates[0].length === 3) {
      if (primitive.properties && primitive.properties.m === true) {
        ret += 'M ';
      } else {
        ret += 'Z ';
      }
    } else if (primitive.coordinates[0].length === 4) {
      ret += 'ZM ';
    }

    ret += arrayToRing(primitive.coordinates);

    return ret;
  }

  function polygonToWKTPolygon(primitive) {
    var ret = 'POLYGON ';

    if (primitive.coordinates === undefined || primitive.coordinates.length === 0 || primitive.coordinates[0].length === 0) {
      ret += 'EMPTY';

      return ret;
    } else if (primitive.coordinates[0][0].length === 3) {
      if (primitive.properties && primitive.properties.m === true) {
        ret += 'M ';
      } else {
        ret += 'Z ';
      }
    } else if (primitive.coordinates[0][0].length === 4) {
      ret += 'ZM ';
    }

    ret += '(';
    var parts = [];
    for (var i = 0; i < primitive.coordinates.length; i++) {
      parts.push(arrayToRing(primitive.coordinates[i]));
    }

    ret += parts.join(', ');
    ret += ')';

    return ret;
  }

  function multiPointToWKTMultiPoint(primitive) {
    var ret = 'MULTIPOINT ';

    if (primitive.coordinates === undefined || primitive.coordinates.length === 0 || primitive.coordinates[0].length === 0) {
      ret += 'EMPTY';

      return ret;
    } else if (primitive.coordinates[0].length === 3) {
      if (primitive.properties && primitive.properties.m === true) {
        ret += 'M ';
      } else {
        ret += 'Z ';
      }
    } else if (primitive.coordinates[0].length === 4) {
      ret += 'ZM ';
    }

    ret += arrayToRing(primitive.coordinates);

    return ret;
  }

  function multiLineStringToWKTMultiLineString(primitive) {
    var ret = 'MULTILINESTRING ';

    if (primitive.coordinates === undefined || primitive.coordinates.length === 0 || primitive.coordinates[0].length === 0) {
      ret += 'EMPTY';

      return ret;
    } else if (primitive.coordinates[0][0].length === 3) {
      if (primitive.properties && primitive.properties.m === true) {
        ret += 'M ';
      } else {
        ret += 'Z ';
      }
    } else if (primitive.coordinates[0][0].length === 4) {
      ret += 'ZM ';
    }

    ret += '(';
    var parts = [];
    for (var i = 0; i < primitive.coordinates.length; i++) {
      parts.push(arrayToRing(primitive.coordinates[i]));
    }

    ret += parts.join(', ');
    ret += ')';

    return ret;
  }

  function multiPolygonToWKTMultiPolygon(primitive) {
    var ret = 'MULTIPOLYGON ';

    if (primitive.coordinates === undefined || primitive.coordinates.length === 0 || primitive.coordinates[0].length === 0 || primitive.coordinates[0][0].length === 0) {
      ret += 'EMPTY';

      return ret;
    } else if (primitive.coordinates[0][0][0].length === 3) {
      if (primitive.properties && primitive.properties.m === true) {
        ret += 'M ';
      } else {
        ret += 'Z ';
      }
    } else if (primitive.coordinates[0][0][0].length === 4) {
      ret += 'ZM ';
    }

    ret += '(';
    var inner = [];
    for (var c = 0; c < primitive.coordinates.length; c++) {
      var it = '(';
      var parts = [];
      for (var i = 0; i < primitive.coordinates[c].length; i++) {
        parts.push(arrayToRing(primitive.coordinates[c][i]));
      }

      it += parts.join(', ');
      it += ')';

      inner.push(it);
    }

    ret += inner.join(', ');
    ret += ')';

    return ret;
  }

  function convert(primitive) {
    switch (primitive.type) {
      case 'Point':
        return pointToWKTPoint(primitive);
      case 'LineString':
        return lineStringToWKTLineString(primitive);
      case 'Polygon':
        return polygonToWKTPolygon(primitive);
      case 'MultiPoint':
        return multiPointToWKTMultiPoint(primitive);
      case 'MultiLineString':
        return multiLineStringToWKTMultiLineString(primitive);
      case 'MultiPolygon':
        return multiPolygonToWKTMultiPolygon(primitive);
      case 'GeometryCollection':
        var ret = 'GEOMETRYCOLLECTION';
        var parts = [];
        for (i = 0; i < primitive.geometries.length; i++) {
          parts.push(convert(primitive.geometries[i]));
        }
        return ret + '(' + parts.join(', ') + ')';
      default:
        throw Error("Unknown Type: " + primitive.type);
    }
  }

  exports.parser = parser;
  exports.Parser = parser.Parser;
  exports.parse = parse;
  exports.convert = convert;

  return exports;
});

/***/ }),

/***/ "V3+0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/***/ }),

/***/ "VS7n":
/***/ (function(module, exports, __webpack_require__) {

module.exports = window.fetch || (window.fetch = __webpack_require__("QAmr").default || __webpack_require__("QAmr"));

/***/ }),

/***/ "X8jb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/***/ }),

/***/ "YdsM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */

module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

/***/ }),

/***/ "ZeD7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

/***/ }),

/***/ "a2Uu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */

module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

/***/ }),

/***/ "aS8y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("3bIi");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

/***/ }),

/***/ "b/1Y":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".stopInfoContainer__HrgkK{background-color:#eee;padding:24px 24px 12px;margin-bottom:24px;margin-top:12px;font-size:16px}", "", {"version":3,"sources":["/home/rc-program-finder/checkout/rideconnection-program-finder/src/components/StopInfo/style.css"],"names":[],"mappings":"AAAA,0BACI,sBAAuB,AACvB,uBAAwB,AACxB,mBAAoB,AACpB,gBAAiB,AACjB,cAAgB,CACnB","file":"style.css","sourcesContent":[".stopInfoContainer {\n    background-color: #eee;\n    padding: 24px 24px 12px;\n    margin-bottom: 24px;\n    margin-top: 12px;\n    font-size: 16px;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"stopInfoContainer": "stopInfoContainer__HrgkK"
};

/***/ }),

/***/ "bEsX":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Ndv3");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "c1Og":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".program__g7yxI{padding:12px 24px;background-color:#eee;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:24px}.col__2mnJi{-webkit-box-flex:1;-ms-flex:1;flex:1;-ms-flex-preferred-size:60%;flex-basis:60%;margin-left:12px;margin-right:12px;-ms-flex-item-align:center;align-self:center}.col__2mnJi:first-child{-ms-flex-preferred-size:40%;flex-basis:40%}.badge__3JBfE{display:inline-block;position:relative;font-size:.6em;padding:6px 12px;border-radius:10px;background-color:#555;color:#fff;cursor:pointer;margin-left:6px;margin-right:6px}.badge__3JBfE:first-child{margin-left:0}.badge__3JBfE:last-child{margin-right:0}.badgeRow__3exgo{margin-bottom:6px;text-align:right}.tooltipText__v-c9K{visibility:hidden;display:inline-block;width:160px;background-color:#000;color:#fff;text-align:left;padding:5px 0;border-radius:6px;position:absolute;z-index:1;bottom:calc(100% + 8px);left:50%;margin-left:-80px;padding:12px}.badge__3JBfE:hover .tooltipText__v-c9K{visibility:visible}.tooltipText__v-c9K:after{content:\" \";position:absolute;top:100%;left:50%;margin-left:-8px;border-width:8px;border-style:solid;border-color:#000 transparent transparent}@media (max-width:650px){.program__g7yxI{display:block}.col__2mnJi:first-child{text-align:center;margin-bottom:12px}.badgeRow__3exgo{text-align:center}}", "", {"version":3,"sources":["/home/rc-program-finder/checkout/rideconnection-program-finder/src/components/Program/style.css"],"names":[],"mappings":"AAAA,gBACI,kBAAmB,AACnB,sBAAuB,AACvB,oBAAc,AAAd,oBAAc,AAAd,aAAc,AACd,yBAA+B,AAA/B,sBAA+B,AAA/B,8BAA+B,AAC/B,kBAAoB,CAEvB,AACD,YACI,mBAAQ,AAAR,WAAQ,AAAR,OAAQ,AACR,4BAAgB,AAAhB,eAAgB,AAChB,iBAAkB,AAClB,kBAAmB,AACnB,2BAAmB,AAAnB,iBAAmB,CAEtB,AACD,wBACI,4BAAgB,AAAhB,cAAgB,CACnB,AAED,cACI,qBAAsB,AACtB,kBAAmB,AACnB,eAAiB,AACjB,iBAAkB,AAClB,mBAAoB,AACpB,sBAAuB,AACvB,WAAY,AACZ,eAAgB,AAChB,gBAAiB,AACjB,gBAAkB,CACrB,AACD,0BACI,aAAe,CAClB,AACD,yBACI,cAAgB,CACnB,AACD,iBACI,kBAAmB,AACnB,gBAAkB,CACrB,AACD,oBACE,kBAAmB,AACnB,qBAAsB,AACtB,YAAa,AACb,sBAAwB,AACxB,WAAY,AACZ,gBAAiB,AACjB,cAAe,AACf,kBAAmB,AACnB,kBAAmB,AACnB,UAAW,AACX,wBAAyB,AACzB,SAAU,AACV,kBAAmB,AACnB,YAAc,CACf,AACD,wCACI,kBAAoB,CACvB,AACD,0BACE,YAAa,AACb,kBAAmB,AACnB,SAAU,AACV,SAAU,AACV,iBAAkB,AAClB,iBAAkB,AAClB,mBAAoB,AACpB,yCAAwD,CACzD,AAED,yBACI,gBACI,aAAe,CAClB,AACD,wBACI,kBAAmB,AACnB,kBAAoB,CACvB,AACD,iBACI,iBAAmB,CACtB,CACJ","file":"style.css","sourcesContent":[".program {\n    padding: 12px 24px;\n    background-color: #eee;\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 24px;\n\n}\n.col {\n    flex: 1;\n    flex-basis: 60%;\n    margin-left: 12px;\n    margin-right: 12px;\n    align-self: center;\n\n}\n.col:first-child {\n    flex-basis: 40%;\n}\n\n.badge {\n    display: inline-block;\n    position: relative;\n    font-size: 0.6em;\n    padding: 6px 12px;\n    border-radius: 10px;\n    background-color: #555;\n    color: #fff;\n    cursor: pointer;\n    margin-left: 6px;\n    margin-right: 6px;\n}\n.badge:first-child {\n    margin-left: 0;\n}\n.badge:last-child {\n    margin-right: 0;\n}\n.badgeRow {\n    margin-bottom: 6px;\n    text-align: right;\n}\n.tooltipText {\n  visibility: hidden;\n  display: inline-block;\n  width: 160px;\n  background-color: black;\n  color: #fff;\n  text-align: left;\n  padding: 5px 0;\n  border-radius: 6px;\n  position: absolute;\n  z-index: 1;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  margin-left: -80px;\n  padding: 12px;\n}\n.badge:hover .tooltipText {\n    visibility: visible;\n}\n.tooltipText::after {\n  content: \" \";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -8px;\n  border-width: 8px;\n  border-style: solid;\n  border-color: black transparent transparent transparent;\n}\n\n@media (max-width:650px) {\n    .program {\n        display: block;\n    }\n    .col:first-child {\n        text-align: center;\n        margin-bottom: 12px;\n    }\n    .badgeRow {\n        text-align: center;\n    }\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"program": "program__g7yxI",
	"col": "col__2mnJi",
	"badge": "badge__3JBfE",
	"badgeRow": "badgeRow__3exgo",
	"tooltipText": "tooltipText__v-c9K"
};

/***/ }),

/***/ "dZBD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("nUiQ");

/***/ }),

/***/ "dn2M":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },

    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },

    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() :

// Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

/***/ }),

/***/ "eEsx":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("b/1Y");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "h6ac":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "jdHL":
/***/ (function(module, exports) {

(function (root, factory) {

  // Node.
  if (typeof module === 'object' && typeof module.exports === 'object') {
    exports = module.exports = factory();
  }

  // Browser Global.
  if (typeof window === "object") {
    root.Terraformer = factory();
  }
})(this, function () {
  "use strict";

  var exports = {},
      EarthRadius = 6378137,
      DegreesPerRadian = 57.295779513082320,
      RadiansPerDegree = 0.017453292519943,
      MercatorCRS = {
    "type": "link",
    "properties": {
      "href": "http://spatialreference.org/ref/sr-org/6928/ogcwkt/",
      "type": "ogcwkt"
    }
  },
      GeographicCRS = {
    "type": "link",
    "properties": {
      "href": "http://spatialreference.org/ref/epsg/4326/ogcwkt/",
      "type": "ogcwkt"
    }
  };

  /*
  Internal: isArray function
  */
  function isArray(obj) {
    return Object.prototype.toString.call(obj) === "[object Array]";
  }

  /*
  Internal: safe warning
  */
  function warn() {
    var args = Array.prototype.slice.apply(arguments);

    if (typeof console !== undefined && console.warn) {
      console.warn.apply(console, args);
    }
  }

  /*
  Internal: Extend one object with another.
  */
  function extend(destination, source) {
    for (var k in source) {
      if (source.hasOwnProperty(k)) {
        destination[k] = source[k];
      }
    }
    return destination;
  }

  /*
  Public: Calculate an bounding box for a geojson object
  */
  function calculateBounds(geojson) {
    if (geojson.type) {
      switch (geojson.type) {
        case 'Point':
          return [geojson.coordinates[0], geojson.coordinates[1], geojson.coordinates[0], geojson.coordinates[1]];

        case 'MultiPoint':
          return calculateBoundsFromArray(geojson.coordinates);

        case 'LineString':
          return calculateBoundsFromArray(geojson.coordinates);

        case 'MultiLineString':
          return calculateBoundsFromNestedArrays(geojson.coordinates);

        case 'Polygon':
          return calculateBoundsFromNestedArrays(geojson.coordinates);

        case 'MultiPolygon':
          return calculateBoundsFromNestedArrayOfArrays(geojson.coordinates);

        case 'Feature':
          return geojson.geometry ? calculateBounds(geojson.geometry) : null;

        case 'FeatureCollection':
          return calculateBoundsForFeatureCollection(geojson);

        case 'GeometryCollection':
          return calculateBoundsForGeometryCollection(geojson);

        default:
          throw new Error("Unknown type: " + geojson.type);
      }
    }
    return null;
  }

  /*
  Internal: Calculate an bounding box from an nested array of positions
  [
    [
      [ [lng, lat],[lng, lat],[lng, lat] ]
    ]
    [
      [lng, lat],[lng, lat],[lng, lat]
    ]
    [
      [lng, lat],[lng, lat],[lng, lat]
    ]
  ]
  */
  function calculateBoundsFromNestedArrays(array) {
    var x1 = null,
        x2 = null,
        y1 = null,
        y2 = null;

    for (var i = 0; i < array.length; i++) {
      var inner = array[i];

      for (var j = 0; j < inner.length; j++) {
        var lonlat = inner[j];

        var lon = lonlat[0];
        var lat = lonlat[1];

        if (x1 === null) {
          x1 = lon;
        } else if (lon < x1) {
          x1 = lon;
        }

        if (x2 === null) {
          x2 = lon;
        } else if (lon > x2) {
          x2 = lon;
        }

        if (y1 === null) {
          y1 = lat;
        } else if (lat < y1) {
          y1 = lat;
        }

        if (y2 === null) {
          y2 = lat;
        } else if (lat > y2) {
          y2 = lat;
        }
      }
    }

    return [x1, y1, x2, y2];
  }

  /*
  Internal: Calculate a bounding box from an array of arrays of arrays
  [
    [ [lng, lat],[lng, lat],[lng, lat] ]
    [ [lng, lat],[lng, lat],[lng, lat] ]
    [ [lng, lat],[lng, lat],[lng, lat] ]
  ]
  */
  function calculateBoundsFromNestedArrayOfArrays(array) {
    var x1 = null,
        x2 = null,
        y1 = null,
        y2 = null;

    for (var i = 0; i < array.length; i++) {
      var inner = array[i];

      for (var j = 0; j < inner.length; j++) {
        var innerinner = inner[j];
        for (var k = 0; k < innerinner.length; k++) {
          var lonlat = innerinner[k];

          var lon = lonlat[0];
          var lat = lonlat[1];

          if (x1 === null) {
            x1 = lon;
          } else if (lon < x1) {
            x1 = lon;
          }

          if (x2 === null) {
            x2 = lon;
          } else if (lon > x2) {
            x2 = lon;
          }

          if (y1 === null) {
            y1 = lat;
          } else if (lat < y1) {
            y1 = lat;
          }

          if (y2 === null) {
            y2 = lat;
          } else if (lat > y2) {
            y2 = lat;
          }
        }
      }
    }

    return [x1, y1, x2, y2];
  }

  /*
  Internal: Calculate a bounding box from an array of positions
  [
    [lng, lat],[lng, lat],[lng, lat]
  ]
  */
  function calculateBoundsFromArray(array) {
    var x1 = null,
        x2 = null,
        y1 = null,
        y2 = null;

    for (var i = 0; i < array.length; i++) {
      var lonlat = array[i];
      var lon = lonlat[0];
      var lat = lonlat[1];

      if (x1 === null) {
        x1 = lon;
      } else if (lon < x1) {
        x1 = lon;
      }

      if (x2 === null) {
        x2 = lon;
      } else if (lon > x2) {
        x2 = lon;
      }

      if (y1 === null) {
        y1 = lat;
      } else if (lat < y1) {
        y1 = lat;
      }

      if (y2 === null) {
        y2 = lat;
      } else if (lat > y2) {
        y2 = lat;
      }
    }

    return [x1, y1, x2, y2];
  }

  /*
  Internal: Calculate an bounding box for a feature collection
  */
  function calculateBoundsForFeatureCollection(featureCollection) {
    var extents = [],
        extent;
    for (var i = featureCollection.features.length - 1; i >= 0; i--) {
      extent = calculateBounds(featureCollection.features[i].geometry);
      extents.push([extent[0], extent[1]]);
      extents.push([extent[2], extent[3]]);
    }

    return calculateBoundsFromArray(extents);
  }

  /*
  Internal: Calculate an bounding box for a geometry collection
  */
  function calculateBoundsForGeometryCollection(geometryCollection) {
    var extents = [],
        extent;

    for (var i = geometryCollection.geometries.length - 1; i >= 0; i--) {
      extent = calculateBounds(geometryCollection.geometries[i]);
      extents.push([extent[0], extent[1]]);
      extents.push([extent[2], extent[3]]);
    }

    return calculateBoundsFromArray(extents);
  }

  function calculateEnvelope(geojson) {
    var bounds = calculateBounds(geojson);
    return {
      x: bounds[0],
      y: bounds[1],
      w: Math.abs(bounds[0] - bounds[2]),
      h: Math.abs(bounds[1] - bounds[3])
    };
  }

  /*
  Internal: Convert radians to degrees. Used by spatial reference converters.
  */
  function radToDeg(rad) {
    return rad * DegreesPerRadian;
  }

  /*
  Internal: Convert degrees to radians. Used by spatial reference converters.
  */
  function degToRad(deg) {
    return deg * RadiansPerDegree;
  }

  /*
  Internal: Loop over each array in a geojson object and apply a function to it. Used by spatial reference converters.
  */
  function eachPosition(coordinates, func) {
    for (var i = 0; i < coordinates.length; i++) {
      // we found a number so lets convert this pair
      if (typeof coordinates[i][0] === "number") {
        coordinates[i] = func(coordinates[i]);
      }
      // we found an coordinates array it again and run THIS function against it
      if (typeof coordinates[i] === "object") {
        coordinates[i] = eachPosition(coordinates[i], func);
      }
    }
    return coordinates;
  }

  /*
  Public: Convert a GeoJSON Position object to Geographic (4326)
  */
  function positionToGeographic(position) {
    var x = position[0];
    var y = position[1];
    return [radToDeg(x / EarthRadius) - Math.floor((radToDeg(x / EarthRadius) + 180) / 360) * 360, radToDeg(Math.PI / 2 - 2 * Math.atan(Math.exp(-1.0 * y / EarthRadius)))];
  }

  /*
  Public: Convert a GeoJSON Position object to Web Mercator (102100)
  */
  function positionToMercator(position) {
    var lng = position[0];
    var lat = Math.max(Math.min(position[1], 89.99999), -89.99999);
    return [degToRad(lng) * EarthRadius, EarthRadius / 2.0 * Math.log((1.0 + Math.sin(degToRad(lat))) / (1.0 - Math.sin(degToRad(lat))))];
  }

  /*
  Public: Apply a function agaist all positions in a geojson object. Used by spatial reference converters.
  */
  function applyConverter(geojson, converter, noCrs) {
    if (geojson.type === "Point") {
      geojson.coordinates = converter(geojson.coordinates);
    } else if (geojson.type === "Feature") {
      geojson.geometry = applyConverter(geojson.geometry, converter, true);
    } else if (geojson.type === "FeatureCollection") {
      for (var f = 0; f < geojson.features.length; f++) {
        geojson.features[f] = applyConverter(geojson.features[f], converter, true);
      }
    } else if (geojson.type === "GeometryCollection") {
      for (var g = 0; g < geojson.geometries.length; g++) {
        geojson.geometries[g] = applyConverter(geojson.geometries[g], converter, true);
      }
    } else {
      geojson.coordinates = eachPosition(geojson.coordinates, converter);
    }

    if (!noCrs) {
      if (converter === positionToMercator) {
        geojson.crs = MercatorCRS;
      }
    }

    if (converter === positionToGeographic) {
      delete geojson.crs;
    }

    return geojson;
  }

  /*
  Public: Convert a GeoJSON object to ESRI Web Mercator (102100)
  */
  function toMercator(geojson) {
    return applyConverter(geojson, positionToMercator);
  }

  /*
  Convert a GeoJSON object to Geographic coordinates (WSG84, 4326)
  */
  function toGeographic(geojson) {
    return applyConverter(geojson, positionToGeographic);
  }

  /*
  Internal: -1,0,1 comparison function
  */
  function cmp(a, b) {
    if (a < b) {
      return -1;
    } else if (a > b) {
      return 1;
    } else {
      return 0;
    }
  }

  /*
  Internal: used for sorting
  */
  function compSort(p1, p2) {
    if (p1[0] > p2[0]) {
      return -1;
    } else if (p1[0] < p2[0]) {
      return 1;
    } else if (p1[1] > p2[1]) {
      return -1;
    } else if (p1[1] < p2[1]) {
      return 1;
    } else {
      return 0;
    }
  }

  /*
  Internal: used to determine turn
  */
  function turn(p, q, r) {
    // Returns -1, 0, 1 if p,q,r forms a right, straight, or left turn.
    return cmp((q[0] - p[0]) * (r[1] - p[1]) - (r[0] - p[0]) * (q[1] - p[1]), 0);
  }

  /*
  Internal: used to determine euclidean distance between two points
  */
  function euclideanDistance(p, q) {
    // Returns the squared Euclidean distance between p and q.
    var dx = q[0] - p[0];
    var dy = q[1] - p[1];

    return dx * dx + dy * dy;
  }

  function nextHullPoint(points, p) {
    // Returns the next point on the convex hull in CCW from p.
    var q = p;
    for (var r in points) {
      var t = turn(p, q, points[r]);
      if (t === -1 || t === 0 && euclideanDistance(p, points[r]) > euclideanDistance(p, q)) {
        q = points[r];
      }
    }
    return q;
  }

  function convexHull(points) {
    // implementation of the Jarvis March algorithm
    // adapted from http://tixxit.wordpress.com/2009/12/09/jarvis-march/

    if (points.length === 0) {
      return [];
    } else if (points.length === 1) {
      return points;
    }

    // Returns the points on the convex hull of points in CCW order.
    var hull = [points.sort(compSort)[0]];

    for (var p = 0; p < hull.length; p++) {
      var q = nextHullPoint(points, hull[p]);

      if (q !== hull[0]) {
        hull.push(q);
      }
    }

    return hull;
  }

  function isConvex(points) {
    var ltz;

    for (var i = 0; i < points.length - 3; i++) {
      var p1 = points[i];
      var p2 = points[i + 1];
      var p3 = points[i + 2];
      var v = [p2[0] - p1[0], p2[1] - p1[1]];

      // p3.x * v.y - p3.y * v.x + v.x * p1.y - v.y * p1.x
      var res = p3[0] * v[1] - p3[1] * v[0] + v[0] * p1[1] - v[1] * p1[0];

      if (i === 0) {
        if (res < 0) {
          ltz = true;
        } else {
          ltz = false;
        }
      } else {
        if (ltz && res > 0 || !ltz && res < 0) {
          return false;
        }
      }
    }

    return true;
  }

  function coordinatesContainPoint(coordinates, point) {
    var contains = false;
    for (var i = -1, l = coordinates.length, j = l - 1; ++i < l; j = i) {
      if ((coordinates[i][1] <= point[1] && point[1] < coordinates[j][1] || coordinates[j][1] <= point[1] && point[1] < coordinates[i][1]) && point[0] < (coordinates[j][0] - coordinates[i][0]) * (point[1] - coordinates[i][1]) / (coordinates[j][1] - coordinates[i][1]) + coordinates[i][0]) {
        contains = !contains;
      }
    }
    return contains;
  }

  function polygonContainsPoint(polygon, point) {
    if (polygon && polygon.length) {
      if (polygon.length === 1) {
        // polygon with no holes
        return coordinatesContainPoint(polygon[0], point);
      } else {
        // polygon with holes
        if (coordinatesContainPoint(polygon[0], point)) {
          for (var i = 1; i < polygon.length; i++) {
            if (coordinatesContainPoint(polygon[i], point)) {
              return false; // found in hole
            }
          }

          return true;
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  }

  function edgeIntersectsEdge(a1, a2, b1, b2) {
    var ua_t = (b2[0] - b1[0]) * (a1[1] - b1[1]) - (b2[1] - b1[1]) * (a1[0] - b1[0]);
    var ub_t = (a2[0] - a1[0]) * (a1[1] - b1[1]) - (a2[1] - a1[1]) * (a1[0] - b1[0]);
    var u_b = (b2[1] - b1[1]) * (a2[0] - a1[0]) - (b2[0] - b1[0]) * (a2[1] - a1[1]);

    if (u_b !== 0) {
      var ua = ua_t / u_b;
      var ub = ub_t / u_b;

      if (0 <= ua && ua <= 1 && 0 <= ub && ub <= 1) {
        return true;
      }
    }

    return false;
  }

  function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  function arraysIntersectArrays(a, b) {
    if (isNumber(a[0][0])) {
      if (isNumber(b[0][0])) {
        for (var i = 0; i < a.length - 1; i++) {
          for (var j = 0; j < b.length - 1; j++) {
            if (edgeIntersectsEdge(a[i], a[i + 1], b[j], b[j + 1])) {
              return true;
            }
          }
        }
      } else {
        for (var k = 0; k < b.length; k++) {
          if (arraysIntersectArrays(a, b[k])) {
            return true;
          }
        }
      }
    } else {
      for (var l = 0; l < a.length; l++) {
        if (arraysIntersectArrays(a[l], b)) {
          return true;
        }
      }
    }
    return false;
  }

  /*
  Internal: Returns a copy of coordinates for s closed polygon
  */
  function closedPolygon(coordinates) {
    var outer = [];

    for (var i = 0; i < coordinates.length; i++) {
      var inner = coordinates[i].slice();
      if (pointsEqual(inner[0], inner[inner.length - 1]) === false) {
        inner.push(inner[0]);
      }

      outer.push(inner);
    }

    return outer;
  }

  function pointsEqual(a, b) {
    for (var i = 0; i < a.length; i++) {

      if (a[i] !== b[i]) {
        return false;
      }
    }

    return true;
  }

  function coordinatesEqual(a, b) {
    if (a.length !== b.length) {
      return false;
    }

    var na = a.slice().sort(compSort);
    var nb = b.slice().sort(compSort);

    for (var i = 0; i < na.length; i++) {
      if (na[i].length !== nb[i].length) {
        return false;
      }
      for (var j = 0; j < na.length; j++) {
        if (na[i][j] !== nb[i][j]) {
          return false;
        }
      }
    }

    return true;
  }

  /*
  Internal: An array of variables that will be excluded form JSON objects.
  */
  var excludeFromJSON = ["length"];

  /*
  Internal: Base GeoJSON Primitive
  */
  function Primitive(geojson) {
    if (geojson) {
      switch (geojson.type) {
        case 'Point':
          return new Point(geojson);

        case 'MultiPoint':
          return new MultiPoint(geojson);

        case 'LineString':
          return new LineString(geojson);

        case 'MultiLineString':
          return new MultiLineString(geojson);

        case 'Polygon':
          return new Polygon(geojson);

        case 'MultiPolygon':
          return new MultiPolygon(geojson);

        case 'Feature':
          return new Feature(geojson);

        case 'FeatureCollection':
          return new FeatureCollection(geojson);

        case 'GeometryCollection':
          return new GeometryCollection(geojson);

        default:
          throw new Error("Unknown type: " + geojson.type);
      }
    }
  }

  Primitive.prototype.toMercator = function () {
    return toMercator(this);
  };

  Primitive.prototype.toGeographic = function () {
    return toGeographic(this);
  };

  Primitive.prototype.envelope = function () {
    return calculateEnvelope(this);
  };

  Primitive.prototype.bbox = function () {
    return calculateBounds(this);
  };

  Primitive.prototype.convexHull = function () {
    var coordinates = [],
        i,
        j;
    if (this.type === 'Point') {
      return null;
    } else if (this.type === 'LineString' || this.type === 'MultiPoint') {
      if (this.coordinates && this.coordinates.length >= 3) {
        coordinates = this.coordinates;
      } else {
        return null;
      }
    } else if (this.type === 'Polygon' || this.type === 'MultiLineString') {
      if (this.coordinates && this.coordinates.length > 0) {
        for (i = 0; i < this.coordinates.length; i++) {
          coordinates = coordinates.concat(this.coordinates[i]);
        }
        if (coordinates.length < 3) {
          return null;
        }
      } else {
        return null;
      }
    } else if (this.type === 'MultiPolygon') {
      if (this.coordinates && this.coordinates.length > 0) {
        for (i = 0; i < this.coordinates.length; i++) {
          for (j = 0; j < this.coordinates[i].length; j++) {
            coordinates = coordinates.concat(this.coordinates[i][j]);
          }
        }
        if (coordinates.length < 3) {
          return null;
        }
      } else {
        return null;
      }
    } else if (this.type === "Feature") {
      var primitive = new Primitive(this.geometry);
      return primitive.convexHull();
    }

    return new Polygon({
      type: 'Polygon',
      coordinates: closedPolygon([convexHull(coordinates)])
    });
  };

  Primitive.prototype.toJSON = function () {
    var obj = {};
    for (var key in this) {
      if (this.hasOwnProperty(key) && excludeFromJSON.indexOf(key) === -1) {
        obj[key] = this[key];
      }
    }
    obj.bbox = calculateBounds(this);
    return obj;
  };

  Primitive.prototype.contains = function (primitive) {
    return new Primitive(primitive).within(this);
  };

  Primitive.prototype.within = function (primitive) {
    var coordinates, i, j, contains;

    // if we are passed a feature, use the polygon inside instead
    if (primitive.type === 'Feature') {
      primitive = primitive.geometry;
    }

    // point.within(point) :: equality
    if (primitive.type === "Point") {
      if (this.type === "Point") {
        return pointsEqual(this.coordinates, primitive.coordinates);
      }
    }

    // point.within(multilinestring)
    if (primitive.type === "MultiLineString") {
      if (this.type === "Point") {
        for (i = 0; i < primitive.coordinates.length; i++) {
          var linestring = { type: "LineString", coordinates: primitive.coordinates[i] };

          if (this.within(linestring)) {
            return true;
          }
        }
      }
    }

    // point.within(linestring), point.within(multipoint)
    if (primitive.type === "LineString" || primitive.type === "MultiPoint") {
      if (this.type === "Point") {
        for (i = 0; i < primitive.coordinates.length; i++) {
          if (this.coordinates.length !== primitive.coordinates[i].length) {
            return false;
          }

          if (pointsEqual(this.coordinates, primitive.coordinates[i])) {
            return true;
          }
        }
      }
    }

    if (primitive.type === "Polygon") {
      // polygon.within(polygon)
      if (this.type === "Polygon") {
        // check for equal polygons
        if (primitive.coordinates.length === this.coordinates.length) {
          for (i = 0; i < this.coordinates.length; i++) {
            if (coordinatesEqual(this.coordinates[i], primitive.coordinates[i])) {
              return true;
            }
          }
        }

        if (this.coordinates.length && polygonContainsPoint(primitive.coordinates, this.coordinates[0][0])) {
          return !arraysIntersectArrays(closedPolygon(this.coordinates), closedPolygon(primitive.coordinates));
        } else {
          return false;
        }

        // point.within(polygon)
      } else if (this.type === "Point") {
        return polygonContainsPoint(primitive.coordinates, this.coordinates);

        // linestring/multipoint withing polygon
      } else if (this.type === "LineString" || this.type === "MultiPoint") {
        if (!this.coordinates || this.coordinates.length === 0) {
          return false;
        }

        for (i = 0; i < this.coordinates.length; i++) {
          if (polygonContainsPoint(primitive.coordinates, this.coordinates[i]) === false) {
            return false;
          }
        }

        return true;

        // multilinestring.within(polygon)
      } else if (this.type === "MultiLineString") {
        for (i = 0; i < this.coordinates.length; i++) {
          var ls = new LineString(this.coordinates[i]);

          if (ls.within(primitive) === false) {
            contains++;
            return false;
          }
        }

        return true;

        // multipolygon.within(polygon)
      } else if (this.type === "MultiPolygon") {
        for (i = 0; i < this.coordinates.length; i++) {
          var p1 = new Primitive({ type: "Polygon", coordinates: this.coordinates[i] });

          if (p1.within(primitive) === false) {
            return false;
          }
        }

        return true;
      }
    }

    if (primitive.type === "MultiPolygon") {
      // point.within(multipolygon)
      if (this.type === "Point") {
        if (primitive.coordinates.length) {
          for (i = 0; i < primitive.coordinates.length; i++) {
            coordinates = primitive.coordinates[i];
            if (polygonContainsPoint(coordinates, this.coordinates) && arraysIntersectArrays([this.coordinates], primitive.coordinates) === false) {
              return true;
            }
          }
        }

        return false;
        // polygon.within(multipolygon)
      } else if (this.type === "Polygon") {
        for (i = 0; i < this.coordinates.length; i++) {
          if (primitive.coordinates[i].length === this.coordinates.length) {
            for (j = 0; j < this.coordinates.length; j++) {
              if (coordinatesEqual(this.coordinates[j], primitive.coordinates[i][j])) {
                return true;
              }
            }
          }
        }

        if (arraysIntersectArrays(this.coordinates, primitive.coordinates) === false) {
          if (primitive.coordinates.length) {
            for (i = 0; i < primitive.coordinates.length; i++) {
              coordinates = primitive.coordinates[i];
              if (polygonContainsPoint(coordinates, this.coordinates[0][0]) === false) {
                contains = false;
              } else {
                contains = true;
              }
            }

            return contains;
          }
        }

        // linestring.within(multipolygon), multipoint.within(multipolygon)
      } else if (this.type === "LineString" || this.type === "MultiPoint") {
        for (i = 0; i < primitive.coordinates.length; i++) {
          var p = { type: "Polygon", coordinates: primitive.coordinates[i] };

          if (this.within(p)) {
            return true;
          }

          return false;
        }

        // multilinestring.within(multipolygon)
      } else if (this.type === "MultiLineString") {
        for (i = 0; i < this.coordinates.length; i++) {
          var lines = new LineString(this.coordinates[i]);

          if (lines.within(primitive) === false) {
            return false;
          }
        }

        return true;

        // multipolygon.within(multipolygon)
      } else if (this.type === "MultiPolygon") {
        for (i = 0; i < primitive.coordinates.length; i++) {
          var mpoly = { type: "Polygon", coordinates: primitive.coordinates[i] };

          if (this.within(mpoly) === false) {
            return false;
          }
        }

        return true;
      }
    }

    // default to false
    return false;
  };

  Primitive.prototype.intersects = function (primitive) {
    // if we are passed a feature, use the polygon inside instead
    if (primitive.type === 'Feature') {
      primitive = primitive.geometry;
    }

    var p = new Primitive(primitive);
    if (this.within(primitive) || p.within(this)) {
      return true;
    }

    if (this.type !== 'Point' && this.type !== 'MultiPoint' && primitive.type !== 'Point' && primitive.type !== 'MultiPoint') {
      return arraysIntersectArrays(this.coordinates, primitive.coordinates);
    } else if (this.type === 'Feature') {
      // in the case of a Feature, use the internal primitive for intersection
      var inner = new Primitive(this.geometry);
      return inner.intersects(primitive);
    }

    warn("Type " + this.type + " to " + primitive.type + " intersection is not supported by intersects");
    return false;
  };

  /*
  GeoJSON Point Class
    new Point();
    new Point(x,y,z,wtf);
    new Point([x,y,z,wtf]);
    new Point([x,y]);
    new Point({
      type: "Point",
      coordinates: [x,y]
    });
  */
  function Point(input) {
    var args = Array.prototype.slice.call(arguments);

    if (input && input.type === "Point" && input.coordinates) {
      extend(this, input);
    } else if (input && isArray(input)) {
      this.coordinates = input;
    } else if (args.length >= 2) {
      this.coordinates = args;
    } else {
      throw "Terraformer: invalid input for Terraformer.Point";
    }

    this.type = "Point";
  }

  Point.prototype = new Primitive();
  Point.prototype.constructor = Point;

  /*
  GeoJSON MultiPoint Class
      new MultiPoint();
      new MultiPoint([[x,y], [x1,y1]]);
      new MultiPoint({
        type: "MultiPoint",
        coordinates: [x,y]
      });
  */
  function MultiPoint(input) {
    if (input && input.type === "MultiPoint" && input.coordinates) {
      extend(this, input);
    } else if (isArray(input)) {
      this.coordinates = input;
    } else {
      throw "Terraformer: invalid input for Terraformer.MultiPoint";
    }

    this.type = "MultiPoint";
  }

  MultiPoint.prototype = new Primitive();
  MultiPoint.prototype.constructor = MultiPoint;
  MultiPoint.prototype.forEach = function (func) {
    for (var i = 0; i < this.coordinates.length; i++) {
      func.apply(this, [this.coordinates[i], i, this.coordinates]);
    }
    return this;
  };
  MultiPoint.prototype.addPoint = function (point) {
    this.coordinates.push(point);
    return this;
  };
  MultiPoint.prototype.insertPoint = function (point, index) {
    this.coordinates.splice(index, 0, point);
    return this;
  };
  MultiPoint.prototype.removePoint = function (remove) {
    if (typeof remove === "number") {
      this.coordinates.splice(remove, 1);
    } else {
      this.coordinates.splice(this.coordinates.indexOf(remove), 1);
    }
    return this;
  };
  MultiPoint.prototype.get = function (i) {
    return new Point(this.coordinates[i]);
  };

  /*
  GeoJSON LineString Class
      new LineString();
      new LineString([[x,y], [x1,y1]]);
      new LineString({
        type: "LineString",
        coordinates: [x,y]
      });
  */
  function LineString(input) {
    if (input && input.type === "LineString" && input.coordinates) {
      extend(this, input);
    } else if (isArray(input)) {
      this.coordinates = input;
    } else {
      throw "Terraformer: invalid input for Terraformer.LineString";
    }

    this.type = "LineString";
  }

  LineString.prototype = new Primitive();
  LineString.prototype.constructor = LineString;
  LineString.prototype.addVertex = function (point) {
    this.coordinates.push(point);
    return this;
  };
  LineString.prototype.insertVertex = function (point, index) {
    this.coordinates.splice(index, 0, point);
    return this;
  };
  LineString.prototype.removeVertex = function (remove) {
    this.coordinates.splice(remove, 1);
    return this;
  };

  /*
  GeoJSON MultiLineString Class
      new MultiLineString();
      new MultiLineString([ [[x,y], [x1,y1]], [[x2,y2], [x3,y3]] ]);
      new MultiLineString({
        type: "MultiLineString",
        coordinates: [ [[x,y], [x1,y1]], [[x2,y2], [x3,y3]] ]
      });
  */
  function MultiLineString(input) {
    if (input && input.type === "MultiLineString" && input.coordinates) {
      extend(this, input);
    } else if (isArray(input)) {
      this.coordinates = input;
    } else {
      throw "Terraformer: invalid input for Terraformer.MultiLineString";
    }

    this.type = "MultiLineString";
  }

  MultiLineString.prototype = new Primitive();
  MultiLineString.prototype.constructor = MultiLineString;
  MultiLineString.prototype.forEach = function (func) {
    for (var i = 0; i < this.coordinates.length; i++) {
      func.apply(this, [this.coordinates[i], i, this.coordinates]);
    }
  };
  MultiLineString.prototype.get = function (i) {
    return new LineString(this.coordinates[i]);
  };

  /*
  GeoJSON Polygon Class
      new Polygon();
      new Polygon([ [[x,y], [x1,y1], [x2,y2]] ]);
      new Polygon({
        type: "Polygon",
        coordinates: [ [[x,y], [x1,y1], [x2,y2]] ]
      });
  */
  function Polygon(input) {
    if (input && input.type === "Polygon" && input.coordinates) {
      extend(this, input);
    } else if (isArray(input)) {
      this.coordinates = input;
    } else {
      throw "Terraformer: invalid input for Terraformer.Polygon";
    }

    this.type = "Polygon";
  }

  Polygon.prototype = new Primitive();
  Polygon.prototype.constructor = Polygon;
  Polygon.prototype.addVertex = function (point) {
    this.insertVertex(point, this.coordinates[0].length - 1);
    return this;
  };
  Polygon.prototype.insertVertex = function (point, index) {
    this.coordinates[0].splice(index, 0, point);
    return this;
  };
  Polygon.prototype.removeVertex = function (remove) {
    this.coordinates[0].splice(remove, 1);
    return this;
  };
  Polygon.prototype.close = function () {
    this.coordinates = closedPolygon(this.coordinates);
  };
  Polygon.prototype.hasHoles = function () {
    return this.coordinates.length > 1;
  };
  Polygon.prototype.holes = function () {
    var holes = [];
    if (this.hasHoles()) {
      for (var i = 1; i < this.coordinates.length; i++) {
        holes.push(new Polygon([this.coordinates[i]]));
      }
    }
    return holes;
  };

  /*
  GeoJSON MultiPolygon Class
      new MultiPolygon();
      new MultiPolygon([ [ [[x,y], [x1,y1]], [[x2,y2], [x3,y3]] ] ]);
      new MultiPolygon({
        type: "MultiPolygon",
        coordinates: [ [ [[x,y], [x1,y1]], [[x2,y2], [x3,y3]] ] ]
      });
  */
  function MultiPolygon(input) {
    if (input && input.type === "MultiPolygon" && input.coordinates) {
      extend(this, input);
    } else if (isArray(input)) {
      this.coordinates = input;
    } else {
      throw "Terraformer: invalid input for Terraformer.MultiPolygon";
    }

    this.type = "MultiPolygon";
  }

  MultiPolygon.prototype = new Primitive();
  MultiPolygon.prototype.constructor = MultiPolygon;
  MultiPolygon.prototype.forEach = function (func) {
    for (var i = 0; i < this.coordinates.length; i++) {
      func.apply(this, [this.coordinates[i], i, this.coordinates]);
    }
  };
  MultiPolygon.prototype.get = function (i) {
    return new Polygon(this.coordinates[i]);
  };
  MultiPolygon.prototype.close = function () {
    var outer = [];
    this.forEach(function (polygon) {
      outer.push(closedPolygon(polygon));
    });
    this.coordinates = outer;
    return this;
  };

  /*
  GeoJSON Feature Class
      new Feature();
      new Feature({
        type: "Feature",
        geometry: {
          type: "Polygon",
          coordinates: [ [ [[x,y], [x1,y1]], [[x2,y2], [x3,y3]] ] ]
        }
      });
      new Feature({
        type: "Polygon",
        coordinates: [ [ [[x,y], [x1,y1]], [[x2,y2], [x3,y3]] ] ]
      });
  */
  function Feature(input) {
    if (input && input.type === "Feature") {
      extend(this, input);
    } else if (input && input.type && input.coordinates) {
      this.geometry = input;
    } else {
      throw "Terraformer: invalid input for Terraformer.Feature";
    }

    this.type = "Feature";
  }

  Feature.prototype = new Primitive();
  Feature.prototype.constructor = Feature;

  /*
  GeoJSON FeatureCollection Class
      new FeatureCollection();
      new FeatureCollection([feature, feature1]);
      new FeatureCollection({
        type: "FeatureCollection",
        coordinates: [feature, feature1]
      });
  */
  function FeatureCollection(input) {
    if (input && input.type === "FeatureCollection" && input.features) {
      extend(this, input);
    } else if (isArray(input)) {
      this.features = input;
    } else {
      throw "Terraformer: invalid input for Terraformer.FeatureCollection";
    }

    this.type = "FeatureCollection";
  }

  FeatureCollection.prototype = new Primitive();
  FeatureCollection.prototype.constructor = FeatureCollection;
  FeatureCollection.prototype.forEach = function (func) {
    for (var i = 0; i < this.features.length; i++) {
      func.apply(this, [this.features[i], i, this.features]);
    }
  };
  FeatureCollection.prototype.get = function (id) {
    var found;
    this.forEach(function (feature) {
      if (feature.id === id) {
        found = feature;
      }
    });
    return new Feature(found);
  };

  /*
  GeoJSON GeometryCollection Class
      new GeometryCollection();
      new GeometryCollection([geometry, geometry1]);
      new GeometryCollection({
        type: "GeometryCollection",
        coordinates: [geometry, geometry1]
      });
  */
  function GeometryCollection(input) {
    if (input && input.type === "GeometryCollection" && input.geometries) {
      extend(this, input);
    } else if (isArray(input)) {
      this.geometries = input;
    } else if (input.coordinates && input.type) {
      this.type = "GeometryCollection";
      this.geometries = [input];
    } else {
      throw "Terraformer: invalid input for Terraformer.GeometryCollection";
    }

    this.type = "GeometryCollection";
  }

  GeometryCollection.prototype = new Primitive();
  GeometryCollection.prototype.constructor = GeometryCollection;
  GeometryCollection.prototype.forEach = function (func) {
    for (var i = 0; i < this.geometries.length; i++) {
      func.apply(this, [this.geometries[i], i, this.geometries]);
    }
  };
  GeometryCollection.prototype.get = function (i) {
    return new Primitive(this.geometries[i]);
  };

  function createCircle(center, radius, interpolate) {
    var mercatorPosition = positionToMercator(center);
    var steps = interpolate || 64;
    var polygon = {
      type: "Polygon",
      coordinates: [[]]
    };
    for (var i = 1; i <= steps; i++) {
      var radians = i * (360 / steps) * Math.PI / 180;
      polygon.coordinates[0].push([mercatorPosition[0] + radius * Math.cos(radians), mercatorPosition[1] + radius * Math.sin(radians)]);
    }
    polygon.coordinates = closedPolygon(polygon.coordinates);

    return toGeographic(polygon);
  }

  function Circle(center, radius, interpolate) {
    var steps = interpolate || 64;
    var rad = radius || 250;

    if (!center || center.length < 2 || !rad || !steps) {
      throw new Error("Terraformer: missing parameter for Terraformer.Circle");
    }

    extend(this, new Feature({
      type: "Feature",
      geometry: createCircle(center, rad, steps),
      properties: {
        radius: rad,
        center: center,
        steps: steps
      }
    }));
  }

  Circle.prototype = new Primitive();
  Circle.prototype.constructor = Circle;
  Circle.prototype.recalculate = function () {
    this.geometry = createCircle(this.properties.center, this.properties.radius, this.properties.steps);
    return this;
  };
  Circle.prototype.center = function (coordinates) {
    if (coordinates) {
      this.properties.center = coordinates;
      this.recalculate();
    }
    return this.properties.center;
  };
  Circle.prototype.radius = function (radius) {
    if (radius) {
      this.properties.radius = radius;
      this.recalculate();
    }
    return this.properties.radius;
  };
  Circle.prototype.steps = function (steps) {
    if (steps) {
      this.properties.steps = steps;
      this.recalculate();
    }
    return this.properties.steps;
  };

  Circle.prototype.toJSON = function () {
    var output = Primitive.prototype.toJSON.call(this);
    return output;
  };

  exports.Primitive = Primitive;
  exports.Point = Point;
  exports.MultiPoint = MultiPoint;
  exports.LineString = LineString;
  exports.MultiLineString = MultiLineString;
  exports.Polygon = Polygon;
  exports.MultiPolygon = MultiPolygon;
  exports.Feature = Feature;
  exports.FeatureCollection = FeatureCollection;
  exports.GeometryCollection = GeometryCollection;
  exports.Circle = Circle;

  exports.toMercator = toMercator;
  exports.toGeographic = toGeographic;

  exports.Tools = {};
  exports.Tools.positionToMercator = positionToMercator;
  exports.Tools.positionToGeographic = positionToGeographic;
  exports.Tools.applyConverter = applyConverter;
  exports.Tools.toMercator = toMercator;
  exports.Tools.toGeographic = toGeographic;
  exports.Tools.createCircle = createCircle;

  exports.Tools.calculateBounds = calculateBounds;
  exports.Tools.calculateEnvelope = calculateEnvelope;

  exports.Tools.coordinatesContainPoint = coordinatesContainPoint;
  exports.Tools.polygonContainsPoint = polygonContainsPoint;
  exports.Tools.arraysIntersectArrays = arraysIntersectArrays;
  exports.Tools.coordinatesContainPoint = coordinatesContainPoint;
  exports.Tools.coordinatesEqual = coordinatesEqual;
  exports.Tools.convexHull = convexHull;
  exports.Tools.isConvex = isConvex;

  exports.MercatorCRS = MercatorCRS;
  exports.GeographicCRS = GeographicCRS;

  return exports;
});

/***/ }),

/***/ "lcwS":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),

/***/ "m+Gh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

if (!global.Promise) global.Promise = __webpack_require__("BtxX");
if (!global.fetch) global.fetch = __webpack_require__("VS7n");
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "mI+K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */

function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

/***/ }),

/***/ "mrbf":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("c1Og");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "nUiQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");
var bind = __webpack_require__("ED/T");
var Axios = __webpack_require__("OvAf");
var mergeConfig = __webpack_require__("2OHv");
var defaults = __webpack_require__("BXyq");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("mI+K");
axios.CancelToken = __webpack_require__("tsWd");
axios.isCancel = __webpack_require__("V3+0");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("X8jb");

// Expose isAxiosError
axios.isAxiosError = __webpack_require__("wICU");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (false) {
	navigator.serviceWorker.register(__webpack_public_path__ + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "rj2i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

/***/ }),

/***/ "tsWd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("mI+K");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

/***/ }),

/***/ "uz6X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");
var transformData = __webpack_require__("woEt");
var isCancel = __webpack_require__("V3+0");
var defaults = __webpack_require__("BXyq");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(config.data, config.headers, config.transformRequest);

  // Flatten headers
  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);

  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(response.data, response.headers, config.transformResponse);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};

/***/ }),

/***/ "wICU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */

module.exports = function isAxiosError(payload) {
  return typeof payload === 'object' && payload.isAxiosError === true;
};

/***/ }),

/***/ "woEt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// bundle.js